// import React, { useEffect, useState, useRef } from "react";
// import { Link } from "react-router-dom";
// import {
//   Box,
//   Card,
//   CardContent,
//   Typography,
//   Button,
//   Slider,
//   Chip,
//   Paper,
//   Stack,
//   Container,
//   IconButton,
//   Tooltip,
//   Backdrop,
//   CircularProgress,
//   Alert,
//   Snackbar,
//   TextField,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Badge,
//   Avatar,
//   Breadcrumbs,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   DialogActions,
// } from "@mui/material";
// import Grid2 from "@mui/material/Unstable_Grid2";
// import {
//   AutoFixHigh as MagicIcon,
//   Article as DocumentIcon,
//   FormatListBulleted as BulletIcon,
//   Tune as CustomIcon,
//   Mic,
//   Upload,
//   Delete,
//   ContentCopy,
//   Download,
//   Stop,
//   TrendingDown,
//   TrendingUp,
//   Transform,
//   Psychology,
//   Create,
//   CloudUpload,
//   Analytics,
//   Speed,
//   AutoFixHigh,
//   Warning as WarningIcon,
// } from "@mui/icons-material";
// import NavigateNextIcon from "@mui/icons-material/NavigateNext";
// import {
//   Editor,
//   EditorState,
//   KeyBindingUtil,
//   ContentState,
//   convertFromHTML,
//   Modifier,
//   SelectionState,
//   RichUtils,
//   CompositeDecorator,
//   convertToRaw,
//   convertFromRaw,
// } from "draft-js";
// import "draft-js/dist/Draft.css";
// import {
//   getCheckSummariser,
//   summarizerKeywords,
// } from "../../../services/summariserService";
// import { checkPhrasing } from "../../../services/englishCheckers";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import SpeechRecognition, {
//   useSpeechRecognition,
// } from "react-speech-recognition";
// import mammoth from "mammoth";
// import Swal from "sweetalert2";
// import { convertToHTML } from "draft-convert";
// import { stateFromHTML } from "draft-js-import-html";
// import { useSelector } from "react-redux";
// import { addUserLogs } from "../../../services/userLogServices";
// import { useCheckFeatureAccess } from "../../CheckFeature";
// import { useCheckSubscriptionPlanAccess } from "../../SubscriptionAccess";
// import SubscriptionRequired from "../../SubscriptionRequired";
// import { checkAIRequestLimit } from "../../aiRequestLimit";
// import styled from "styled-components";
// import { useHistory } from "react-router-dom";
// import jwtDecode from "jwt-decode";
// import Poetlogopen from "../../../static/POET_Logo_Pen.png";

// const VisuallyHiddenInput = styled("input")({
//   clip: "rect(0 0 0 0)",
//   clipPath: "inset(50%)",
//   height: 1,
//   overflow: "hidden",
//   position: "absolute",
//   bottom: 0,
//   left: 0,
//   whiteSpace: "nowrap",
//   width: 1,
// });

// // Styled components for better layout control
// const StyledCard = styled(Card)`
//   display: flex;
//   flex-direction: column;
//   flex: 1;
//   min-height: 0;
//   height: 100%;
// `;

// const CardContentScrollable = styled(CardContent)`
//   flex: 1;
//   display: flex;
//   flex-direction: column;
//   padding: 0 !important;
//   min-height: 0;
// `;

// const EditorContainer = styled(Box)`
//   flex: 1;
//   overflow: auto;
//   min-height: 0;
//   height: 100%;
// `;

// const ModeButton = styled(Button)(({ active, disabled }) => ({
//   borderRadius: "12px",
//   padding: "12px 20px",
//   textTransform: "none",
//   fontWeight: 600,
//   fontSize: "0.95rem",
//   transition: "all 0.3s ease",
//   border: "2px solid #e2e8f0",
//   minWidth: "160px",
//   display: "flex",
//   flexDirection: "column",
//   alignItems: "center",
//   justifyContent: "center",
//   gap: "8px",
//   height: "100%",

//   // Active state
//   ...(active && {
//     backgroundColor: "#6366f1",
//     color: "white",
//     borderColor: "#6366f1",
//     boxShadow: "0 4px 12px rgba(99, 102, 241, 0.3)",
//     transform: "translateY(-2px)",
//     "&:hover": {
//       backgroundColor: "#4f46e5",
//       boxShadow: "0 6px 16px rgba(99, 102, 241, 0.4)",
//     },
//     "& .MuiSvgIcon-root": {
//       color: "white",
//     },
//     "& .mode-description": {
//       color: "rgba(65, 86, 153, 0.9)",
//     },
//   }),

//   // Inactive state
//   ...(!active && {
//     backgroundColor: "transparent",
//     color: "#1f2937",
//     borderColor: "#e2e8f0",
//     "&:hover": {
//       backgroundColor: "#f3f4f6",
//       borderColor: "#6366f1",
//       transform: "translateY(-1px)",
//       boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
//     },
//     "& .MuiSvgIcon-root": {
//       color: "#6b7280",
//     },
//     "& .mode-description": {
//       color: "#6b7280",
//     },
//   }),

//   // Disabled state
//   ...(disabled && {
//     opacity: 0.5,
//     cursor: "not-allowed",
//     pointerEvents: "none",
//     "&:hover": {
//       transform: "none",
//       boxShadow: "none",
//       borderColor: "#e2e8f0",
//     },
//   }),
// }));

// const ModernSummarizer = () => {
//   const userDetails = useSelector((user) => user);
//   // const userID = userDetails?.currentUser?._id || "";
//   const token = sessionStorage.getItem("token");

//   const getUserIdentity = () => {
//     const token =
//       sessionStorage.getItem("token") || localStorage.getItem("token");

//     if (!token) return null;

//     try {
//       const decoded = jwtDecode(token);
//       console.log("🔓 DECODED TOKEN:", decoded);
//       // 🟡 GUEST
//       if (decoded.role === "guest" || decoded.authType === "guest") {
//         console.log("🟡 Guest detected → machineId:", decoded.machineId);
//         return {
//           machineId: decoded.machineId,
//         };
//       }

//       // 🟢 LOGIN USER
//       if (decoded._id) {
//         return {
//           userId: decoded._id,
//         };
//       }

//       return null;
//     } catch (err) {
//       console.error("Invalid token");
//       return null;
//     }
//   };

//   const [loading, setLoading] = useState(false);
//   const [editorState1, setEditorState1] = useState(() =>
//     EditorState.createEmpty(),
//   );
//   const [textLength1, setTextLength1] = useState();
//   const history = useHistory();
//   const [editorStatePara, setEditorStatePara] = useState("");
//   const [paragraphState, setParagraphState] = useState();
//   const [selectedButtons, setSelectedButtons] = useState([]);
//   const [isVisible, setIsVisible] = useState(false);
//   const [totalWords, setTotalWords] = useState(0);
//   const [totalWords2, setTotalWords2] = useState(0);
//   const [activeLink, setActiveLink] = useState(null);
//   const [APIData, setAPIData] = useState(false);
//   const [sliderValue, setSliderValue] = useState(0);
//   const [sliderText, setSliderText] = useState("Shorten");
//   const [keywords, setKeywords] = useState([]);
//   const [selectedKeywords, setSelectedKeywords] = useState();
//   const [isBulletPoints, setIsBulletPoints] = useState(false);
//   const [noOfBullets, setNoOfBullets] = useState(0);
//   const [isParagraph, setIsParagraph] = useState(false);
//   const [isCustom, setIsCustom] = useState(false);
//   const [customPrompt, setCustomPrompt] = useState("");
//   const [isKeyword, setIsKeyword] = useState(false);
//   const [maxCountDisplayed, setMaxCountDisplayed] = useState(false);
//   const [isSummarize, setIsSummarize] = useState(false);
//   const { transcript, resetTranscript } = useSpeechRecognition();
//   const [isRecording, setIsRecording] = useState(false);
//   const [isContinuousListening, setIsContinuousListening] = useState(false);
//   const [windowWidth, setWindowWidth] = useState(window.innerWidth);
//   const [inputKey, setInputKey] = useState();
//   const [showSuccess, setShowSuccess] = useState(false);
//   const [successMessage, setSuccessMessage] = useState("");
//   const [noOfParagraphs, setNoOfParagraphs] = useState(0);
//   const [customModeText, setCustomModeText] = useState("");

//   // State for word limit warning dialog
//   const [wordLimitDialogOpen, setWordLimitDialogOpen] = useState(false);
//   const [wordLimitExceeded, setWordLimitExceeded] = useState(false);

//   // Access control hooks
//   const accessToUpload = useCheckFeatureAccess("summarizer", "upload");
//   const accessToSummarise = useCheckFeatureAccess("summarizer", "summarizer");
//   const accessToSummarizerScreen = useCheckSubscriptionPlanAccess("Summarizer");
//   const [subReqOpen, setSubReqOpen] = useState(false);
//   const [isFeatureInside, setIsFeatureInside] = useState(false);

//   const accessTocustom = useCheckSubscriptionPlanAccess("custom");
//   const accessToMic = useCheckSubscriptionPlanAccess("mic");

//   useEffect(() => {
//     if (accessToSummarizerScreen == false) {
//       setSubReqOpen(true);
//     }
//   }, [accessToSummarizerScreen]);

//   const { hasCommandModifier } = KeyBindingUtil;
//   let [keyCode, setKeyCode] = useState(null);
//   const sliderMarks = [
//     { value: 0, label: "0%" },
//     { value: 20, label: "20%" },
//     { value: 40, label: "40%" },
//     { value: 60, label: "60%" },
//     { value: 80, label: "80%" },
//     { value: 100, label: "100%" },
//   ];

//   let maxWords = 1500;
//   const [words, setWords] = useState([]);

//   useEffect(() => {
//     // Lock body scroll and remove layout spacing for full screen
//     document.body.style.margin = "0";
//     document.body.style.padding = "0";
//     document.body.style.height = "100vh";
//     document.body.style.overflow = "hidden";
//     document.documentElement.style.height = "100vh";
//     document.documentElement.style.overflow = "hidden";

//     return () => {
//       document.body.style.margin = "";
//       document.body.style.padding = "";
//       document.body.style.height = "";
//       document.body.style.overflow = "auto";
//       document.documentElement.style.height = "";
//       document.documentElement.style.overflow = "auto";
//     };
//   }, []);

//   // Dark mode state
//   const [isDarkMode, setIsDarkMode] = useState(false);
//   useEffect(() => {
//     const updateTheme = () => {
//       const theme = localStorage.getItem("ThemeSwitch");
//       setIsDarkMode(theme === "true");
//     };
//     updateTheme();
//     window.addEventListener("storage", updateTheme);
//     const originalSetItem = localStorage.setItem;
//     localStorage.setItem = function (key, value) {
//       originalSetItem.apply(this, arguments);
//       if (key === "ThemeSwitch") {
//         updateTheme();
//       }
//     };
//     return () => {
//       window.removeEventListener("storage", updateTheme);
//       localStorage.setItem = originalSetItem;
//     };
//   }, []);

//   // Decorator for highlighting
//   const Decorated = ({ children }) => {
//     return <span style={{ color: "darkorange" }}>{children}</span>;
//   };

//   function findWithRegex(words, contentBlock, callback) {
//     const text = contentBlock.getText();
//     words.forEach((word) => {
//       const matches = [...text.matchAll(word)];
//       matches.forEach((match) =>
//         callback(match.index, match.index + match[0].length),
//       );
//     });
//   }

//   function handleStrategy(contentBlock, callback) {
//     findWithRegex(words, contentBlock, callback);
//   }

//   const createDecorator = () => {
//     return new CompositeDecorator([
//       {
//         strategy: handleStrategy,
//         component: Decorated,
//       },
//     ]);
//   };

//   const [editorState2, setEditorState2] = useState(
//     EditorState.createEmpty(new CompositeDecorator([])),
//   );
//   const [originalText, setOriginalText] = useState("");
//   const [paraphrasedText, setParaphrasedText] = useState("");
//   const editor = useRef(null);

//   function focusEditor() {
//     editor.current.focus();
//   }

//   const highlightDecorator = (newWords) => {
//     return new CompositeDecorator([
//       {
//         strategy: (contentBlock, callback) => {
//           const text = contentBlock.getText();
//           newWords.forEach((newWord) => {
//             const escapedNewWord = newWord.replace(
//               /[.*+?^${}()|[\]\\]/g,
//               "\\$&",
//             );
//             const regex = new RegExp(
//               `(?:^|\\W)${escapedNewWord}(?:\\W|$)`,
//               "gi",
//             );
//             let match;
//             while ((match = regex.exec(text)) !== null) {
//               const startIndex = match.index;
//               const endIndex = startIndex + match[0].length;
//               callback(startIndex, endIndex);
//             }
//           });
//         },
//         component: Decorated,
//       },
//     ]);
//   };
//   const handleBreadcrumbClick = (event, path) => {
//     event.preventDefault();
//     window.location.href = "/docTags";
//     // history.push(path);
//   };
//   const changeColors = () => {
//     const originalTokens = originalText.split(/\s+/);
//     const paraphrasedTokens = paraphrasedText.split(/\s+/);
//     const newWords = paraphrasedTokens.filter(
//       (word) => !originalTokens.includes(word),
//     );
//     const dec = highlightDecorator(newWords);
//     const contentState = ContentState.createFromText(paraphrasedText);
//     setEditorState2(EditorState.createWithContent(contentState, dec));
//   };

//   useEffect(() => {
//     if (paraphrasedText !== "") {
//       changeColors();
//     }
//   }, [paraphrasedText]);

//   useEffect(() => {
//     if (undefined !== selectedKeywords) {
//       summarizeByKeyWord();
//     }
//   }, [selectedKeywords]);

//   const handleWordCountExceed = () => {
//     if (!maxCountDisplayed) {
//       toast.warn("Word count exceeded than 1500");
//       setMaxCountDisplayed(true);
//     }
//   };

//   // MIC FUNCTIONALITY
//   const handleMicClick = () => {
//     if (accessToMic == false) {
//       setSubReqOpen(true);
//       setIsFeatureInside(true);
//       return;
//     }
//     if (SpeechRecognition.browserSupportsSpeechRecognition()) {
//       if (isRecording) {
//         SpeechRecognition.stopListening();
//       } else {
//         SpeechRecognition.startListening({ continuous: true });
//       }
//       setIsRecording(!isRecording);
//     } else {
//       toast.error("Speech recognition is not supported by your browser.");
//     }
//   };

//   const handleTranscriptChange = () => {
//     if (transcript) {
//       handleSpeechInput(transcript);
//     }
//   };

//   useEffect(() => {
//     return () => {
//       if (isRecording) {
//         SpeechRecognition.stopListening();
//         resetTranscript();
//       }
//     };
//   }, [isRecording]);

//   const handleSpeechInput = (input) => {
//     const currentText = editorState1.getCurrentContent().getPlainText();
//     const newText = `${currentText} ${input}`;
//     const newContentState = ContentState.createFromText(newText);
//     const newEditorState = EditorState.createWithContent(newContentState);
//     setEditorState1(newEditorState);
//   };

//   useEffect(() => {
//     handleTranscriptChange();
//     if (transcript.length > 2) {
//       resetTranscript();
//     }
//   }, [transcript]);

//   useEffect(() => {
//     if (isCustom) {
//       if (customPrompt == "") {
//         setIsSummarize(true);
//       } else {
//         setIsSummarize(false);
//       }
//     }
//   }, [customPrompt]);

//   useEffect(() => {
//     if (isCustom == false) {
//       setIsSummarize(false);
//     }
//   }, [isCustom]);

//   useEffect(() => {
//     updateWordCount();
//   }, [editorState1]);

//   useEffect(() => {
//     updateWordCount2();
//   }, [editorState2]);

//   const updateWordCount = () => {
//     let contentState = editorState1.getCurrentContent();
//     let hasText = contentState.hasText();
//     if (hasText) {
//       let currentText = contentState.getPlainText();
//       let wordCount = currentText.trim().split(/\s+/).length;
//       setTotalWords(wordCount);
//     } else {
//       setTotalWords(0);
//     }
//   };

//   const countWords = (editorState) => {
//     const contentState = editorState.getCurrentContent();
//     const rawText = convertToRaw(contentState)
//       .blocks.map((block) => block.text.trim())
//       .join(" ")
//       .trim();
//     return rawText.length > 0 ? rawText.split(/\s+/).length : 0;
//   };

//   const wordCountEditor1 = countWords(editorState1);

//   const updateWordCount2 = () => {
//     let contentState = editorState2.getCurrentContent();
//     let hasText = contentState.hasText();
//     if (hasText) {
//       let currentText = contentState.getPlainText();
//       let wordCount = currentText.trim().split(/\s+/).length;
//       setTotalWords2(wordCount);
//     } else {
//       setTotalWords2(0);
//     }
//   };

//   // Function to count paragraphs
//   const countParagraphs = (text) => {
//     if (!text || text.trim() === "") return 0;

//     const paragraphs = text
//       .split(/\n\s*\n/)
//       .filter((para) => para.trim() !== "");

//     if (paragraphs.length === 0) {
//       const lines = text.split("\n").filter((line) => line.trim() !== "");
//       return lines.length > 0 ? 1 : 0;
//     }

//     return paragraphs.length;
//   };

//   // Check if output has content
//   const hasOutputContent = () => {
//     return editorState2.getCurrentContent().hasText();
//   };

//   const handleKeyWords = async (e) => {
//     // const checkailimit = await checkAIRequestLimit(getUserIdentity());
//     // if (checkailimit == false) {
//     //   toast.warn("AI request limit reached.");
//     //   return;
//     // }
//     let value = e.target.value;
//     setSelectedKeywords(value);
//   };

//   const handleDeleteClick = () => {
//     setEditorState1(EditorState.createEmpty());
//     setEditorState2(EditorState.createEmpty());
//     setEditorStatePara("");
//     setTotalWords(0);
//     setTotalWords2(0);
//     setSliderValue(0);
//     setSliderText("Shorten");
//     setIsCustom(false);
//     setIsVisible(false);
//     setMaxCountDisplayed(false);
//     resetTranscript();
//     setNoOfParagraphs(0);
//     setActiveLink(null);
//     setCustomModeText("");
//     setSuccessMessage("Content cleared successfully!");
//     setShowSuccess(true);
//   };

//   const handleDeleteClick2 = () => {
//     setEditorState2(EditorState.createEmpty());
//     setEditorStatePara("");
//     setTotalWords2(0);
//     setSliderValue(0);
//     setSliderText("Shorten");
//     setIsCustom(false);
//     setActiveLink(null);
//     setCustomPrompt("");
//     setCustomModeText("");
//     setMaxCountDisplayed(false);
//     resetTranscript();
//     setIsBulletPoints(false);
//     setNoOfParagraphs(0);
//     setIsVisible(false);
//     setSuccessMessage("Output cleared successfully!");
//     setShowSuccess(true);
//   };

//   const summarizeByKeyWord = async () => {
//     setLoading(true);
//     let plainText;
//     const selection = editorState1.getSelection();
//     plainText = editorState1
//       .getCurrentContent()
//       .getBlockForKey(selection.getAnchorKey())
//       .getText()
//       .slice(selection.getStartOffset(), selection.getEndOffset());

//     if (!plainText) {
//       plainText = editorState1.getCurrentContent().getPlainText();
//     }

//     let sendData = {
//       text: selectedKeywords,
//       content: plainText,
//       prompts: "three",
//       // userId: userID,
//       ...getUserIdentity(),
//       isCoAuthor: false,
//     };

//     try {
//       let response = await getCheckSummariser(sendData);
//       if (response.data.output[0].startsWith("\n")) {
//         response.data.output[0] = response.data.output[0].substring(1);
//       }
//       const summaryText = response.data.output.join("\n");
//       const newContentState = ContentState.createFromText(summaryText);
//       let newEditorState = EditorState.createWithContent(newContentState);
//       setEditorState2(newEditorState);
//       setActiveLink("paragraph");
//       setEditorStatePara(newEditorState.getCurrentContent().getPlainText());

//       const paragraphCount = countParagraphs(summaryText);
//       setNoOfParagraphs(paragraphCount);

//       const identity = getUserIdentity();

//       if (identity) {
//         await addUserLogs({
//           ...identity,
//           actionType: "summariser",
//         });
//       }
//     } catch (e) {
//       console.log("summarizeByKeyWorderror", e);
//       setActiveLink(null);
//     }
//     setLoading(false);
//   };

//   const summarizeByPercentage = async (value) => {
//     let promptValue = "four";
//     let newValue;
//     if (value == 0) {
//       handleSummeriseClick(false);
//       return;
//     } else if (value < 60) {
//       newValue = 100 - value;
//       promptValue = "four";
//     } else if (value == 60) {
//       newValue = 40;
//       promptValue = "five";
//     } else if (value > 60) {
//       newValue = value;
//       promptValue = "five";
//     }

//     let plainText;
//     const selection = editorState1.getSelection();
//     plainText = editorState1
//       .getCurrentContent()
//       .getBlockForKey(selection.getAnchorKey())
//       .getText()
//       .slice(selection.getStartOffset(), selection.getEndOffset());

//     if (!plainText) {
//       plainText = editorState1.getCurrentContent().getPlainText();
//     }

//     let sendData = {
//       text: newValue.toString() + "%",
//       content: plainText,
//       prompts: promptValue,
//       ...getUserIdentity(),
//       // userId: userID,
//       isCoAuthor: false,
//     };

//     setLoading(true);
//     try {
//       let response = await getCheckSummariser(sendData);
//       if (response.data.output[0].startsWith("\n")) {
//         response.data.output[0] = response.data.output[0].substring(1);
//       }
//       const summaryText = response.data.output.join("\n");
//       const newContentState = ContentState.createFromText(summaryText);
//       let newEditorState = EditorState.createWithContent(newContentState);
//       setEditorState2(newEditorState);
//       setActiveLink("paragraph");
//       setEditorStatePara(newEditorState.getCurrentContent().getPlainText());

//       const paragraphCount = countParagraphs(summaryText);
//       setNoOfParagraphs(paragraphCount);
//       const identity = getUserIdentity();

//       if (identity) {
//         await addUserLogs({
//           ...identity,
//           actionType: "summariser",
//         });
//       }
//     } catch (e) {
//       setActiveLink(null);
//       console.log("summarizeByPercentageerror", e);
//     }
//     setLoading(false);
//   };

//   const handleCopyEditor1 = () => {
//     let sentence = editorState1.getCurrentContent().getPlainText();
//     if (sentence == "") {
//       toast.warn(`You don't have text, to copy`);
//       return;
//     }
//     navigator.clipboard.writeText(sentence).then(
//       function () {
//         setSuccessMessage("Text copied successfully!");
//         setShowSuccess(true);
//       },
//       function (err) {
//         console.error("Async: Could not copy text: ", err);
//       },
//     );
//   };

//   const handleCopyEditor2 = () => {
//     let sentence = editorState2.getCurrentContent().getPlainText();
//     if (sentence == "") {
//       toast.warn(`You don't have text, to copy`);
//       return;
//     }
//     navigator.clipboard.writeText(sentence).then(
//       function () {
//         setSuccessMessage("Summary copied successfully!");
//         setShowSuccess(true);
//       },
//       function (err) {
//         console.error("Async: Could not copy text: ", err);
//       },
//     );
//   };

//   const handleDownload = () => {
//     if (!editorState2.getCurrentContent().getPlainText()) {
//       toast.warn(`You don't have text, to download`);
//       return;
//     }
//     const blob = new Blob([editorState2.getCurrentContent().getPlainText()], {
//       type: "text/plain",
//     });
//     const anchor = document.createElement("a");
//     anchor.href = URL.createObjectURL(blob);
//     anchor.download = "text_content.txt";
//     anchor.click();
//     URL.revokeObjectURL(anchor.href);
//     setSuccessMessage("File downloaded successfully!");
//     setShowSuccess(true);
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     if (file.type === "application/pdf") {
//       toast.warn("PDF format is not supported.");
//       return;
//     }

//     if (file.size > 4194304) {
//       Swal.fire({
//         title: "Document exceeded the limit of 4 Mb!",
//         icon: "error",
//         confirmButtonText: "ok",
//       });
//       return;
//     }

//     if (
//       file.type ===
//       "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
//     ) {
//       let reader = new FileReader();
//       reader.onload = function (event) {
//         mammoth
//           .convertToHtml({ arrayBuffer: event.target.result })
//           .then(function (result) {
//             const contentState = stateFromHTML(result.value);
//             setEditorState1(EditorState.createWithContent(contentState));
//             setSuccessMessage("File uploaded successfully!");
//             setShowSuccess(true);
//           })
//           .done();
//       };
//       reader.readAsArrayBuffer(file);
//     } else if (file.type === "text/plain") {
//       let reader = new FileReader();
//       reader.onload = function (event) {
//         const contentState = ContentState.createFromText(event.target.result);
//         setEditorState1(EditorState.createWithContent(contentState));
//         setSuccessMessage("File uploaded successfully!");
//         setShowSuccess(true);
//       };
//       reader.readAsText(file);
//     } else {
//       toast.info(
//         "Your file format is not supported, Please upload txt or doc files.",
//       );
//     }
//   };

//   const handleParaphrase = async () => {
//     setActiveLink("paragraph");
//     setAPIData(false);
//     setIsBulletPoints(false);
//     setIsParagraph(true);
//     setIsCustom(false);
//     setIsKeyword(true);
//     GrammerCheckForParaphrase();
//   };

//   const handleCustomPrompt = (e) => {
//     let value = e.target.value;
//     setCustomPrompt(value);
//   };

//   const GrammerCheckForParaphrase = async (type) => {
//     let plainText;
//     const selection = editorState2.getSelection();
//     plainText = editorState2
//       .getCurrentContent()
//       .getBlockForKey(selection.getAnchorKey())
//       .getText()
//       .slice(selection.getStartOffset(), selection.getEndOffset());

//     if (!plainText) {
//       plainText = editorState2.getCurrentContent().getPlainText();
//     }

//     let data = {
//       text: plainText,
//       tone: "defaultPrompt",
//       ...getUserIdentity(),
//       // userId: userID,
//       isCoAuthor: false,
//     };

//     setLoading(true);
//     try {
//       let paraphraseResponse = await checkPhrasing(data);
//       if (paraphraseResponse.data !== "") {
//         if (paraphraseResponse.data.output[0].startsWith("\n")) {
//           paraphraseResponse.data.output[0] =
//             paraphraseResponse.data.output[0].substring(1);
//         }
//         const summaryText = paraphraseResponse.data.output.join("\n");
//         let responseOutput = ContentState.createFromText(summaryText);
//         let newEditorState = EditorState.createWithContent(responseOutput);
//         setEditorState2(newEditorState);
//         handleReplaceText(newEditorState);
//         setEditorStatePara(newEditorState.getCurrentContent().getPlainText());

//         const paragraphCount = countParagraphs(summaryText);
//         setNoOfParagraphs(paragraphCount);

//         const identity = getUserIdentity();

//         if (identity) {
//           await addUserLogs({
//             ...identity,
//             actionType: "paraphrase",
//           });
//         }
//       }
//     } catch (e) {
//       console.log("error", e);
//     }
//     setLoading(false);
//   };

//   const handleReplaceText = (newEditorState) => {
//     let newState = newEditorState.getCurrentContent();
//     let newText = newState.getPlainText();
//     let previousState = editorState2.getCurrentContent();
//     let previousText = previousState.getPlainText();
//     const replacedContentState = ContentState.createFromText(newText);
//     setOriginalText(previousText);
//     setParaphrasedText(newText);
//   };

//   const handleParagraph = () => {
//     const contentState = ContentState.createFromText(editorStatePara);
//     const editorStateWithText = EditorState.createWithContent(contentState);
//     setEditorState2(editorStateWithText);

//     const paragraphCount = countParagraphs(editorStatePara);
//     setNoOfParagraphs(paragraphCount);

//     return;
//   };

//   const handleLinkClick = (linkType) => {
//     setActiveLink(linkType);

//     // Reset all states first
//     setIsBulletPoints(false);
//     setIsParagraph(false);
//     setIsCustom(false);
//     setCustomPrompt("");
//     setIsKeyword(false);

//     if (linkType === "bullets") {
//       setAPIData(true);
//       setIsBulletPoints(true);
//       handleApplyBullets();
//     } else if (linkType === "paragraph") {
//       setAPIData(false);
//       setIsParagraph(true);
//       setIsKeyword(true);
//       handleParagraph();
//     } else if (linkType === "custom") {
//       setIsCustom(true);
//       setIsSummarize(true);
//       setCustomModeText("Enter custom instructions...");
//     }
//   };

//   const handleCustomModeApply = () => {
//     if (accessTocustom == false) {
//       setSubReqOpen(true);
//       setIsFeatureInside(true);
//       return;
//     }

//     if (customPrompt.trim() !== "") {
//       handleSummeriseClick(false);
//       setCustomModeText(
//         `Custom: ${customPrompt.substring(0, 30)}${customPrompt.length > 30 ? "..." : ""}`,
//       );
//     }
//   };

//   const handleEditorChange = (newEditorState) => {
//     const contentState = newEditorState.getCurrentContent();
//     const currentText = contentState.getPlainText();
//     let hasText = contentState.hasText();
//     const wordCount = currentText.split(/\s+/).length;
//     setEditorState1(newEditorState);
//     setMaxCountDisplayed(false);
//     setTotalWords(hasText ? wordCount : 0);
//   };

//   const handleEditorChange2 = (newEditorState) => {
//     const contentState = newEditorState.getCurrentContent();
//     const currentText = contentState.getPlainText();
//     const wordCount = currentText.split(/\s+/).length;

//     let lines = currentText.split("\n").filter((line) => line.trim() !== "");
//     let textWithoutEmptyLines = lines.join("\n");
//     const sentenceSplitPattern = /(?<!\b(?:[A-Z][a-z]*\.?\s?)+)\.\s+/;
//     let sentences = textWithoutEmptyLines
//       .split(sentenceSplitPattern)
//       .filter((sentence) => sentence.trim() !== "")
//       .map((sentence) => sentence.replace(/\n/g, ""));

//     let hasText = contentState.hasText();
//     if (wordCount > maxWords) {
//       handleWordCountExceed();
//       return;
//     }

//     setNoOfBullets(sentences.length);
//     setTotalWords2(hasText ? wordCount : 0);
//     setEditorState2(newEditorState);
//     setMaxCountDisplayed(false);

//     if (isParagraph) {
//       const paragraphCount = countParagraphs(currentText);
//       setNoOfParagraphs(paragraphCount);
//     }

//     if (hasText && !isVisible) {
//       setIsVisible(true);
//     } else if (!hasText && isVisible) {
//       setIsVisible(false);
//     }
//   };

//   // Updated handleSummeriseClick with word limit check
//   const handleSummeriseClick = async (isDefault) => {
//     // Check if word count exceeds limit
//     const wordCount = editorState1
//       .getCurrentContent()
//       .getPlainText()
//       .split(/\s+/).length;

//     if (wordCount > 1500) {
//       setWordLimitDialogOpen(true);
//       setWordLimitExceeded(true);
//       return;
//     }

//     setLoading(true);
//     try {
//       if (
//         editorState1.getCurrentContent().getPlainText().split(/\s+/).length -
//           1 ==
//         0
//       ) {
//         toast.warn("Please enter text");
//         return;
//       } else {
//         const contentState = editorState1.getCurrentContent();
//         let plainText;
//         const selection = editorState1.getSelection();
//         plainText = editorState1
//           .getCurrentContent()
//           .getBlockForKey(selection.getAnchorKey())
//           .getText()
//           .slice(selection.getStartOffset(), selection.getEndOffset());

//         if (!plainText) {
//           plainText = contentState.getPlainText();
//         }

//         let sendData = {
//           text: plainText,
//           content: "",
//           prompts: isDefault ? "one" : "seven",
//           ...getUserIdentity(),
//           // userId: userID,
//           isCoAuthor: false,
//         };

//         if (customPrompt !== "") {
//           sendData = {
//             text: customPrompt,
//             content: plainText,
//             prompts: "six",
//             ...getUserIdentity(),
//             // userId: userID,
//             isCoAuthor: false,
//           };
//         }

//         setLoading(true);
//         let generateSummary = await getCheckSummariser(sendData);
//         if (generateSummary.data.output[0].startsWith("\n")) {
//           generateSummary.data.output[0] =
//             generateSummary.data.output[0].substring(1);
//         }
//         const summaryText = generateSummary.data.output.join("\n");
//         const newContentState = ContentState.createFromText(summaryText);
//         const newEditorState = EditorState.createWithContent(newContentState);
//         setEditorState2(newEditorState);
//         setActiveLink("paragraph");
//         setEditorStatePara(newEditorState.getCurrentContent().getPlainText());

//         // Update paragraph count
//         const paragraphCount = countParagraphs(summaryText);
//         setNoOfParagraphs(paragraphCount);

//         let sendData2 = {
//           text: plainText,
//           prompts: "two",
//           ...getUserIdentity(),
//           // userId: userID,
//           isCoAuthor: false,
//         };

//         let generateKeywords = await getCheckSummariser(sendData2);
//         let text = generateKeywords.data.output[0];

//         let allkeywords = text
//           .split(/\n/)
//           .map((line) => line.trim())
//           .filter((line) => line.length > 0)
//           .map((line) => line.replace(/^[\d.-\s]*/, ""));

//         let formattedKeywords = allkeywords.map((keyword) => ({
//           name: keyword,
//           value: keyword,
//         }));

//         setKeywords(formattedKeywords);
//         setIsVisible(true);
//         setIsKeyword(isCustom ? false : true);
//         const identity = getUserIdentity();

//         if (identity) {
//           await addUserLogs({
//             ...identity,
//             actionType: "summariser",
//           });
//         }
//       }
//     } catch (error) {
//       console.error("summarizeClick", error);
//       toast.error("Error Occurred");
//     }
//     setLoading(false);
//   };

//   const handleApplyBullets = () => {
//     let hasText = editorState2.getCurrentContent().hasText();
//     if (!hasText) {
//       toast.info("No content to add bullets");
//       return;
//     }
//     setIsBulletPoints(true);
//     setIsParagraph(false);
//     setIsCustom(false);
//     setIsKeyword(true);

//     let text = editorState2.getCurrentContent().getPlainText();

//     let lines = text.split("\n").filter((line) => line.trim() !== "");
//     let textWithoutEmptyLines = lines.join("\n");

//     const sentenceSplitPattern = /(?<!\b(?:[A-Z][a-z]*\.?\s?)+)\.\s+/;
//     let sentences = textWithoutEmptyLines
//       .split(sentenceSplitPattern)
//       .filter((sentence) => sentence.trim() !== "")
//       .map((sentence) => sentence.replace(/\n/g, ""));
//     setNoOfBullets(sentences.length);

//     let formattedText = sentences.join(".\n");
//     let newContent = ContentState.createFromText(formattedText);
//     let newEditorState = EditorState.createWithContent(newContent);
//     let newEditorStateExt = newEditorState.getCurrentContent();
//     let firstBlock = newEditorStateExt.getFirstBlock();
//     let lastBlock = newEditorStateExt.getLastBlock();
//     let firstBlockKey = firstBlock.getKey();
//     let lastBlockKey = lastBlock.getKey();
//     let firstBlockLength = firstBlock.getLength();
//     let lastBlockLength = lastBlock.getLength();
//     let selection = newEditorState.getSelection().merge({
//       anchorKey: firstBlockKey,
//       anchorOffset: 0,
//       focusKey: lastBlockKey,
//       focusOffset: lastBlockLength,
//     });
//     let selectedState = EditorState.forceSelection(newEditorState, selection);
//     setParagraphState(selectedState);

//     let newEditorState2 = RichUtils.toggleBlockType(
//       selectedState,
//       "unordered-list-item",
//     );
//     setEditorState2(newEditorState2);
//   };

//   const handleSliderChange = async (event, newValue) => {
//     const percentage = ((newValue - 0) / (100 - 0)) * 100;
//     setSliderValue(newValue);
//     setSliderText(newValue >= 60 ? "Expand" : "Shorten");
//     summarizeByPercentage(newValue);
//   };

//   // Handle word limit dialog close
//   const handleWordLimitDialogClose = () => {
//     setWordLimitDialogOpen(false);
//     setWordLimitExceeded(false);
//   };

//   // Update windowWidth on resize
//   useEffect(() => {
//     const handleResize = () => setWindowWidth(window.innerWidth);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const modes = [
//     {
//       id: "paragraph",
//       label: "Paragraph",
//       icon: DocumentIcon,
//       description: "Traditional paragraph format",
//     },
//     {
//       id: "bullets",
//       label: "Bullet Points",
//       icon: BulletIcon,
//       description: "Convert to bullet points",
//     },
//   ];

//   return (
//     <>
//       <SubscriptionRequired
//         open={subReqOpen}
//         setOpen={setSubReqOpen}
//         isFeatureInside={isFeatureInside}
//         setIsFeatureInside={setIsFeatureInside}
//         path={"Summarizer"}
//       />

//       {/* Word Limit Warning Dialog */}
//       <Dialog
//         open={wordLimitDialogOpen}
//         onClose={handleWordLimitDialogClose}
//         aria-labelledby="word-limit-dialog-title"
//         aria-describedby="word-limit-dialog-description"
//         sx={{
//           "& .MuiDialog-paper": {
//             borderRadius: 3,
//             padding: 2,
//             minWidth: 400,
//             background: isDarkMode ? "#1e293b" : "#ffffff",
//             color: isDarkMode ? "#ffffff" : "#000000",
//           },
//         }}
//       >
//         <DialogTitle
//           id="word-limit-dialog-title"
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             gap: 1,
//             color: "#ef4444",
//             fontWeight: 600,
//           }}
//         >
//           <WarningIcon sx={{ fontSize: 28 }} />
//           Word Limit Exceeded
//         </DialogTitle>
//         <DialogContent>
//           <DialogContentText
//             id="word-limit-dialog-description"
//             sx={{
//               color: isDarkMode ? "#94a3b8" : "#4b5563",
//               fontSize: "1rem",
//             }}
//           >
//             You have entered <strong>{wordCountEditor1}</strong> words, which
//             exceeds the maximum limit of <strong>1500 words</strong>.
//           </DialogContentText>
//           <Box
//             sx={{
//               mt: 2,
//               p: 2,
//               bgcolor: isDarkMode ? "#334155" : "#f3f4f6",
//               borderRadius: 2,
//             }}
//           >
//             <Typography
//               variant="body2"
//               sx={{ color: isDarkMode ? "#e2e8f0" : "#1f2937" }}
//             >
//               Please reduce your text to 1500 words or less to continue.
//             </Typography>
//           </Box>
//         </DialogContent>
//         <DialogActions sx={{ p: 2, pt: 0 }}>
//           <Button
//             onClick={handleWordLimitDialogClose}
//             variant="contained"
//             sx={{
//               bgcolor: "#ef4444",
//               "&:hover": {
//                 bgcolor: "#dc2626",
//               },
//               borderRadius: 2,
//               px: 4,
//             }}
//           >
//             OK, Got it
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <ToastContainer
//         position="top-right"
//         autoClose={3000}
//         hideProgressBar={false}
//         newestOnTop
//         closeOnClick
//         rtl={false}
//         pauseOnFocusLoss
//         draggable
//         pauseOnHover
//         theme="colored"
//       />

//       <Box
//         sx={{
//           position: "fixed",
//           top: 0,
//           left: 0,
//           right: 0,
//           bottom: 0,
//           overflow: "hidden",
//           background: isDarkMode
//             ? "linear-gradient(135deg, #000000 0%, #000000 100%)"
//             : "linear-gradient(135deg, #ffffffff 0%, #d3d1d1ff)",
//           display: "flex",
//           flexDirection: "column",
//         }}
//       >
//         <Container
//           maxWidth={false}
//           disableGutters
//           sx={{
//             flex: 1,
//             display: "flex",
//             flexDirection: "column",
//             height: "100%",
//             width: "100%",
//             px: 2,
//             py: 1.5,
//           }}
//         >
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               position: "relative",
//               width: "100%",
//               mb: 1.5,
//               flexShrink: 0,
//             }}
//           >
//             {/* LEFT SIDE - Breadcrumb */}
//             <Box sx={{ display: "flex", alignItems: "center" }}>
//               <Paper
//                 elevation={1}
//                 sx={{
//                   p: 1.5,
//                   bgcolor: "white",
//                   borderRadius: 3,
//                   border: "1px solid",
//                   borderColor: "divider",
//                   transition: "all 0.3s ease",
//                   "&:hover": {
//                     boxShadow: "0 4px 12px rgba(102, 126, 234, 0.15)",
//                   },
//                 }}
//               >
//                 <Breadcrumbs
//                   separator={
//                     <NavigateNextIcon
//                       fontSize="small"
//                       sx={{ color: "#667eea" }}
//                     />
//                   }
//                   aria-label="breadcrumb"
//                   sx={{
//                     display: "flex",
//                     alignItems: "center",
//                     flexWrap: "nowrap",
//                   }}
//                 >
//                   <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                     <Box
//                       sx={{
//                         bgcolor: "white",
//                         borderRadius: 2,
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         width: 32,
//                         height: 32,
//                         mr: 2,
//                         boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//                       }}
//                     >
//                       <img
//                         alt="logo"
//                         src={Poetlogopen}
//                         style={{
//                           height: "28px",
//                           width: "28px",
//                           objectFit: "contain",
//                           bgcolor: "white",
//                           // filter: "drop-shadow(0 0 7px rgba(93, 0, 255, 0.65))",
//                           filter:
//                             "drop-shadow(0 0 7px rgba(163, 163, 164, 0.65))",
//                         }}
//                       />
//                     </Box>
//                     <AutoFixHigh sx={{ fontSize: 20, color: "#667eea" }} />

//                     <Link
//                       to="/docTags"
//                       onClick={(e) => handleBreadcrumbClick(e, "/docTags")}
//                       style={{
//                         textDecoration: "none",
//                         color: "#667eea",
//                         fontWeight: 500,
//                         fontSize: "0.95rem",
//                         padding: "4px 8px",
//                         borderRadius: "6px",
//                         whiteSpace: "nowrap",
//                       }}
//                     >
//                       MultiTool AI
//                     </Link>

//                     <NavigateNextIcon
//                       fontSize="small"
//                       sx={{ color: "#667eea" }}
//                     />

//                     <Typography
//                       sx={{
//                         color: "#1a1a1a",
//                         fontWeight: 600,
//                         fontSize: "0.95rem",
//                         padding: "4px 8px",
//                         borderRadius: "6px",
//                         backgroundColor: "rgba(102, 126, 234, 0.08)",
//                         whiteSpace: "nowrap",
//                       }}
//                     >
//                       AI Summarizer
//                     </Typography>
//                   </Box>
//                 </Breadcrumbs>
//               </Paper>
//             </Box>

//             {/* CENTER CONTENT */}
//             <Box
//               sx={{
//                 position: "absolute",
//                 left: "50%",
//                 transform: "translateX(-50%)",
//                 textAlign: "center",
//               }}
//             >
//               <Typography
//                 sx={{
//                   fontSize: 22,
//                   fontWeight: 700,
//                   color: "primary.main",
//                 }}
//               >
//                 AI Summarizer
//               </Typography>

//               <Typography
//                 variant="caption"
//                 sx={{
//                   color: "text.secondary",
//                   fontStyle: "italic",
//                 }}
//               >
//                 Transform your text with intelligent summarization
//               </Typography>
//             </Box>
//           </Box>

//           {/* Mode Selection - Redesigned */}
//           <Card
//             sx={{
//               mb: 1.5,
//               borderRadius: 4,
//               background: isDarkMode
//                 ? "rgba(30, 41, 59, 0.95)"
//                 : "rgba(255,255,255,0.95)",
//               backdropFilter: "blur(10px)",
//               boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
//               border: isDarkMode ? "1px solid #475569" : "1px solid #e2e8f0",
//               flexShrink: 0,
//             }}
//           >
//             <CardContent sx={{ p: 1 }}>
//               <Grid2 container spacing={1} alignItems="center">
//                 <Grid2 item xs={12} md={8}>
//                   <Box sx={{ mb: 1 }}>
//                     <Typography
//                       variant="subtitle1"
//                       fontWeight={600}
//                       sx={{
//                         color: isDarkMode ? "white" : "text.primary",
//                       }}
//                     >
//                       Output Format
//                     </Typography>
//                     <Typography
//                       variant="caption"
//                       sx={{
//                         color: isDarkMode ? "#94a3b8" : "text.primary",
//                       }}
//                     >
//                       Select how you want to display the summarized content
//                     </Typography>
//                   </Box>

//                   <Grid2 container spacing={2}>
//                     {modes.map((mode) => {
//                       const IconComponent = mode.icon;
//                       const isActive = activeLink === mode.id;
//                       const isDisabled =
//                         mode.id === "custom" && !hasOutputContent()
//                           ? false
//                           : !hasOutputContent();

//                       return (
//                         <Grid2 item xs={12} sm={4} key={mode.id}>
//                           <ModeButton
//                             fullWidth
//                             active={isActive}
//                             disabled={isDisabled}
//                             onClick={() => handleLinkClick(mode.id)}
//                           >
//                             <Box
//                               sx={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 gap: 1,
//                               }}
//                             >
//                               <IconComponent
//                                 className="mode-description"
//                                 sx={{
//                                   fontSize: 20,
//                                   color: isActive ? "black" : "black",
//                                 }}
//                               />

//                               <Typography
//                                 variant="caption"
//                                 className="mode-description"
//                                 sx={{
//                                   color: isActive ? "black" : "black",
//                                   whiteSpace: "nowrap",
//                                 }}
//                               >
//                                 {mode.description}
//                               </Typography>
//                             </Box>
//                           </ModeButton>
//                         </Grid2>
//                       );
//                     })}
//                   </Grid2>
//                 </Grid2>

//                 <Grid2 item xs={12} md={4}>
//                   <Box
//                     sx={{
//                       p: 0.5,
//                       borderRadius: 3,
//                       bgcolor: isDarkMode
//                         ? "rgba(255,255,255,0.05)"
//                         : "rgba(0,0,0,0.02)",
//                       border: `1px solid ${isDarkMode ? "#475569" : "#e2e8f0"}`,
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 2,
//                       }}
//                     >
//                       <TrendingDown
//                         color={sliderValue >= 60 ? "secondary" : "primary"}
//                       />
//                       <Box sx={{ flex: 1 }}>
//                         <Typography
//                           variant="body2"
//                           sx={{
//                             color: isDarkMode ? "#94a3b8" : "text.primary",
//                           }}
//                         >
//                           {sliderText} Text
//                         </Typography>
//                         <Slider
//                           value={sliderValue}
//                           onChange={handleSliderChange}
//                           step={20}
//                           marks={sliderMarks}
//                           min={0}
//                           max={100}
//                           disabled={!hasOutputContent()}
//                           sx={{
//                             "& .MuiSlider-thumb": {
//                               background:
//                                 sliderValue >= 60
//                                   ? "linear-gradient(45deg, #f97316, #ea580c)"
//                                   : "linear-gradient(45deg, #667eea, #764ba2)",
//                               border: "3px solid white",
//                               boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
//                             },
//                             "& .MuiSlider-track": {
//                               background:
//                                 sliderValue >= 60
//                                   ? "linear-gradient(45deg, #f97316, #ea580c)"
//                                   : "linear-gradient(45deg, #667eea, #764ba2)",
//                             },
//                           }}
//                         />
//                       </Box>
//                       <TrendingUp
//                         color={sliderValue >= 60 ? "primary" : "primary"}
//                       />
//                     </Box>
//                     <Typography
//                       variant="caption"
//                       sx={{
//                         display: "block",
//                         textAlign: "center",
//                         color: isDarkMode ? "#94a3b8" : "text.primary",
//                       }}
//                     >
//                       Adjust length: {sliderValue}%
//                     </Typography>
//                   </Box>
//                 </Grid2>
//               </Grid2>
//             </CardContent>
//           </Card>

//           {/* Main Content - Takes remaining height */}
//           <Box sx={{ flex: 1, minHeight: 0, width: "100%" }}>
//             <Grid2 container spacing={2} sx={{ height: "100%" }}>
//               {/* Input Panel */}
//               <Grid2 item xs={12} lg={6} sx={{ height: "100%" }}>
//                 <StyledCard
//                   sx={{
//                     borderRadius: 4,
//                     background: isDarkMode
//                       ? "rgba(30, 41, 59, 0.95)"
//                       : "rgba(255,255,255,0.95)",
//                     backdropFilter: "blur(10px)",
//                     boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
//                     height: "100%",
//                   }}
//                 >
//                   {/* Input Header */}
//                   <Box
//                     sx={{
//                       background: "linear-gradient(45deg, #667eea, #764ba2)",
//                       color: "white",
//                       p: 1,
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 1,
//                       position: "relative",
//                       flexShrink: 0,
//                     }}
//                   >
//                     <Avatar sx={{ bgcolor: "rgba(255,255,255,0.2)" }}>
//                       <Create />
//                     </Avatar>
//                     <Box sx={{ flexGrow: 1 }}>
//                       <Typography variant="h6" fontWeight={600}>
//                         Input Text
//                       </Typography>
//                       <Typography variant="body2" sx={{ opacity: 0.9 }}>
//                         Enter or upload your content
//                       </Typography>
//                     </Box>
//                     <Badge
//                       badgeContent={totalWords}
//                       max={1500}
//                       color={wordCountEditor1 > 1500 ? "error" : "warning"}
//                     >
//                       <Chip
//                         label={`${wordCountEditor1}/1500`}
//                         size="small"
//                         sx={{
//                           bgcolor:
//                             wordCountEditor1 > 1500
//                               ? "#ef4444"
//                               : "rgba(255,255,255,0.2)",
//                           color: "white",
//                           fontWeight: 600,
//                         }}
//                       />
//                     </Badge>
//                   </Box>

//                   {/* Editor */}
//                   <CardContentScrollable>
//                     <EditorContainer
//                       sx={{
//                         p: 2,
//                         flex: 1,
//                         minHeight: 0,
//                         height: "100%",
//                         overflow: "auto",
//                         "& .DraftEditor-root": {
//                           color: isDarkMode ? "white" : "inherit",
//                           height: "100%",
//                         },
//                         "& .public-DraftEditor-content": {
//                           height: "100%",
//                         },
//                         "& .public-DraftEditorPlaceholder-root": {
//                           color: isDarkMode ? "#94a3b8" : "#999",
//                         },
//                       }}
//                     >
//                       <Editor
//                         editorState={editorState1}
//                         onChange={handleEditorChange}
//                         placeholder="Start typing your text here, or use the upload button to add a document..."
//                       />
//                     </EditorContainer>
//                   </CardContentScrollable>

//                   {/* Action Bar */}
//                   <Box
//                     sx={{
//                       p: 1,
//                       background: isDarkMode
//                         ? "linear-gradient(45deg, #334155, #475569)"
//                         : "linear-gradient(45deg, #f8fafc, #e2e8f0)",
//                       borderTop: isDarkMode
//                         ? "1px solid #475569"
//                         : "1px solid #e2e8f0",
//                       flexShrink: 0,
//                     }}
//                   >
//                     <Stack
//                       direction="row"
//                       spacing={1}
//                       justifyContent="space-between"
//                       alignItems="center"
//                     >
//                       <Stack direction="row" spacing={1}>
//                         <Tooltip title="Voice Input">
//                           <IconButton
//                             onClick={handleMicClick}
//                             disabled={!accessToSummarise}
//                             sx={{
//                               color: isRecording
//                                 ? "#ef4444"
//                                 : isDarkMode
//                                   ? "#94a3b8"
//                                   : "#6b7280",
//                               animation: isRecording
//                                 ? "pulse 1s infinite"
//                                 : "none",
//                             }}
//                           >
//                             {isRecording ? <Stop /> : <Mic />}
//                           </IconButton>
//                         </Tooltip>
//                         <Tooltip title="Upload Document">
//                           <IconButton
//                             component="label"
//                             disabled={!accessToUpload}
//                             sx={{ color: isDarkMode ? "#94a3b8" : "#6366f1" }}
//                           >
//                             <CloudUpload />
//                             <VisuallyHiddenInput
//                               type="file"
//                               key={inputKey}
//                               onChange={handleFileChange}
//                               accept=".txt,.doc,.docx"
//                             />
//                           </IconButton>
//                         </Tooltip>
//                         <Tooltip title="Clear All">
//                           <IconButton
//                             onClick={handleDeleteClick}
//                             sx={{ color: "#ef4444" }}
//                           >
//                             <Delete />
//                           </IconButton>
//                         </Tooltip>
//                         <Tooltip title="Copy Text">
//                           <IconButton
//                             onClick={handleCopyEditor1}
//                             sx={{ color: "#10b981" }}
//                           >
//                             <ContentCopy />
//                           </IconButton>
//                         </Tooltip>
//                       </Stack>

//                       <Button
//                         variant="contained"
//                         size="large"
//                         onClick={() => handleSummeriseClick(true)}
//                         startIcon={<MagicIcon />}
//                         disabled={
//                           loading ||
//                           totalWords === 0 ||
//                           isSummarize ||
//                           !accessToSummarise
//                         }
//                         sx={{
//                           background:
//                             wordCountEditor1 > 1500
//                               ? "#ef4444"
//                               : "linear-gradient(45deg, #667eea, #764ba2)",
//                           borderRadius: 3,
//                           px: 3,
//                           py: 1.5,
//                           fontWeight: 600,
//                           fontSize: "1.1rem",
//                           boxShadow:
//                             wordCountEditor1 > 1500
//                               ? "0 4px 16px rgba(239,68,68,0.4)"
//                               : "0 4px 16px rgba(102,126,234,0.4)",
//                           "&:hover": {
//                             transform: "translateY(-2px)",
//                             boxShadow:
//                               wordCountEditor1 > 1500
//                                 ? "0 8px 24px rgba(239,68,68,0.6)"
//                                 : "0 8px 24px rgba(102,126,234,0.6)",
//                           },
//                           transition: "all 0.3s ease",
//                         }}
//                       >
//                         {loading ? "Processing..." : "Summarize"}
//                       </Button>
//                     </Stack>
//                   </Box>
//                 </StyledCard>
//               </Grid2>

//               {/* Output Panel */}
//               <Grid2 item xs={12} lg={6} sx={{ height: "100%" }}>
//                 <StyledCard
//                   sx={{
//                     borderRadius: 4,
//                     height: "100%",
//                     background: isDarkMode
//                       ? "rgba(30, 41, 59, 0.95)"
//                       : "rgba(255,255,255,0.95)",
//                     backdropFilter: "blur(10px)",
//                     boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
//                   }}
//                 >
//                   {/* HEADER */}
//                   <Box
//                     sx={{
//                       background: "linear-gradient(45deg, #10b981, #059669)",
//                       color: "white",
//                       p: 1,
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 1,
//                       flexShrink: 0,
//                     }}
//                   >
//                     <Avatar sx={{ bgcolor: "rgba(255,255,255,0.2)" }}>
//                       <Analytics />
//                     </Avatar>
//                     <Box sx={{ flexGrow: 1 }}>
//                       <Typography variant="h6" fontWeight={600}>
//                         Generated Summary
//                       </Typography>
//                       <Typography variant="body2" sx={{ opacity: 0.9 }}>
//                         {hasOutputContent()
//                           ? "Processed content"
//                           : "Processed content"}
//                       </Typography>
//                     </Box>
//                     {hasOutputContent() && (
//                       <Chip
//                         label={`${totalWords2} ${totalWords2 === 1 ? "word" : "words"}`}
//                         size="small"
//                         sx={{
//                           bgcolor: "rgba(255,255,255,0.2)",
//                           color: "white",
//                           fontWeight: 600,
//                           "& .MuiChip-label": {
//                             px: 2,
//                           },
//                         }}
//                       />
//                     )}
//                   </Box>

//                   {/* SCROLLABLE CONTENT */}
//                   <Box
//                     sx={{
//                       flex: 1,
//                       minHeight: 0,
//                       overflow: "auto",
//                       p: 2,
//                       display: "flex",
//                       flexDirection: "column",
//                       color: isDarkMode ? "#94a3b8" : "#6b7280",
//                       justifyContent: hasOutputContent()
//                         ? "flex-start"
//                         : "center",
//                     }}
//                   >
//                     {!hasOutputContent() ? (
//                       <Box
//                         sx={{
//                           display: "flex",
//                           flexDirection: "column",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           height: "100%",
//                           minHeight: "300px",
//                           width: "100%",
//                           textAlign: "center",
//                         }}
//                       >
//                         <Psychology
//                           sx={{ fontSize: 64, mb: 2, opacity: 0.3 }}
//                         />
//                         <Typography variant="h6">Ready to Summarize</Typography>
//                         <Typography
//                           variant="body2"
//                           textAlign="center"
//                           sx={{ maxWidth: 300 }}
//                         >
//                           Enter your text and click summarize to see the magic
//                           happen
//                         </Typography>
//                       </Box>
//                     ) : (
//                       <Editor
//                         ref={editor}
//                         editorState={editorState2}
//                         onChange={handleEditorChange2}
//                       />
//                     )}
//                   </Box>

//                   {/* FOOTER */}
//                   {hasOutputContent() && (
//                     <Box
//                       sx={{
//                         p: 1,
//                         borderTop: "1px solid",
//                         borderColor: "divider",
//                         flexShrink: 0,
//                       }}
//                     >
//                       <Stack
//                         direction="row"
//                         spacing={1}
//                         justifyContent="space-between"
//                         alignItems="center"
//                       >
//                         <Stack direction="row" spacing={1}>
//                           <Tooltip title="Clear Output">
//                             <IconButton
//                               onClick={handleDeleteClick2}
//                               sx={{ color: "#ef4444" }}
//                             >
//                               <Delete />
//                             </IconButton>
//                           </Tooltip>
//                           <Tooltip title="Copy Summary">
//                             <IconButton
//                               onClick={handleCopyEditor2}
//                               sx={{ color: "#10b981" }}
//                             >
//                               <ContentCopy />
//                             </IconButton>
//                           </Tooltip>
//                           <Tooltip title="Download">
//                             <IconButton
//                               onClick={handleDownload}
//                               sx={{ color: "#3b82f6" }}
//                             >
//                               <Download />
//                             </IconButton>
//                           </Tooltip>
//                         </Stack>

//                         <Button
//                           variant="contained"
//                           size="large"
//                           onClick={handleParaphrase}
//                           startIcon={<Transform />}
//                           disabled={loading}
//                           sx={{
//                             background:
//                               "linear-gradient(45deg, #10b981, #059669)",
//                             borderRadius: 3,
//                             px: 3,
//                             py: 1.5,
//                             fontWeight: 600,
//                             fontSize: "1.1rem",
//                             boxShadow: "0 4px 16px rgba(16,185,129,0.4)",
//                             "&:hover": {
//                               transform: "translateY(-2px)",
//                               boxShadow: "0 8px 24px rgba(16,185,129,0.6)",
//                             },
//                             transition: "all 0.3s ease",
//                           }}
//                         >
//                           Paraphrase
//                         </Button>
//                       </Stack>
//                     </Box>
//                   )}
//                 </StyledCard>
//               </Grid2>
//             </Grid2>
//           </Box>

//           {/* Loading Backdrop */}
//           <Backdrop open={loading} sx={{ color: "#fff" }}>
//             <Box sx={{ textAlign: "center" }}>
//               <CircularProgress color="inherit" size={60} sx={{ mb: 2 }} />
//               <Typography variant="h6">Processing your content...</Typography>
//               <Typography variant="body2" sx={{ opacity: 0.8 }}>
//                 AI is working its magic
//               </Typography>
//             </Box>
//           </Backdrop>

//           {/* Success Snackbar */}
//           <Snackbar
//             open={showSuccess}
//             autoHideDuration={3000}
//             onClose={() => setShowSuccess(false)}
//             anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
//           >
//             <Alert
//               severity="success"
//               sx={{
//                 borderRadius: 2,
//                 backgroundColor: isDarkMode ? "#065f46" : undefined,
//                 color: isDarkMode ? "white" : undefined,
//               }}
//             >
//               {successMessage || "Action completed successfully!"}
//             </Alert>
//           </Snackbar>
//         </Container>

//         <style jsx>{`
//           @keyframes pulse {
//             0%,
//             100% {
//               opacity: 1;
//             }
//             50% {
//               opacity: 0.5;
//             }
//           }
//         `}</style>
//       </Box>
//     </>
//   );
// };

// export default ModernSummarizer;

import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Slider,
  Chip,
  Paper,
  Stack,
  Container,
  IconButton,
  Tooltip,
  Backdrop,
  CircularProgress,
  Alert,
  Snackbar,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Badge,
  Avatar,
  Breadcrumbs,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import {
  AutoFixHigh as MagicIcon,
  Article as DocumentIcon,
  FormatListBulleted as BulletIcon,
  Tune as CustomIcon,
  Mic,
  Upload,
  Delete,
  ContentCopy,
  Download,
  Stop,
  TrendingDown,
  TrendingUp,
  Transform,
  Psychology,
  Create,
  CloudUpload,
  Analytics,
  Speed,
  AutoFixHigh,
  Warning as WarningIcon,
} from "@mui/icons-material";
import { withStyles } from "@material-ui/core/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {
  Editor,
  EditorState,
  KeyBindingUtil,
  ContentState,
  convertFromHTML,
  Modifier,
  SelectionState,
  RichUtils,
  CompositeDecorator,
  convertToRaw,
  convertFromRaw,
} from "draft-js";
import "draft-js/dist/Draft.css";
import {
  getCheckSummariser,
  summarizerKeywords,
} from "../../../services/summariserService";
import { checkPhrasing } from "../../../services/englishCheckers";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import mammoth from "mammoth";
import Swal from "sweetalert2";
import { convertToHTML } from "draft-convert";
import { stateFromHTML } from "draft-js-import-html";
import { useSelector } from "react-redux";
import { addUserLogs } from "../../../services/userLogServices";
import { useCheckFeatureAccess } from "../../CheckFeature";
import { useCheckSubscriptionPlanAccess } from "../../SubscriptionAccess";
// Fixed import - SubscriptionRequired should be imported from a different path
// Let's comment this out and import from the correct location
// import SubscriptionRequired from "../../SubscriptionAccess";
// Based on your error, SubscriptionRequired might be exported from a different file
// Let's import it from the correct path - assuming it's in the same directory as useCheckSubscriptionPlanAccess
import SubscriptionRequired from "../../SubscriptionRequired";
import { checkAIRequestLimit } from "../../aiRequestLimit";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import jwtDecode from "jwt-decode";
import Poetlogopen from "../../../static/POET_Logo_Pen.png";

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "blue",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip);

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

// Styled components for better layout control
const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  height: 100%;
`;

const CardContentScrollable = styled(CardContent)`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0 !important;
  min-height: 0;
`;

const EditorContainer = styled(Box)`
  flex: 1;
  overflow: auto;
  min-height: 0;
  height: 100%;
`;

const ModeButton = styled(Button)(({ active, disabled }) => ({
  borderRadius: "12px",
  padding: "12px 20px",
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.95rem",
  transition: "all 0.3s ease",
  border: "2px solid #e2e8f0",
  minWidth: "160px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
  height: "100%",

  // Active state
  ...(active && {
    backgroundColor: "#6366f1",
    color: "white",
    borderColor: "#6366f1",
    boxShadow: "0 4px 12px rgba(99, 102, 241, 0.3)",
    transform: "translateY(-2px)",
    "&:hover": {
      backgroundColor: "#4f46e5",
      boxShadow: "0 6px 16px rgba(99, 102, 241, 0.4)",
    },
    "& .MuiSvgIcon-root": {
      color: "white",
    },
    "& .mode-description": {
      color: "rgba(65, 86, 153, 0.9)",
    },
  }),

  // Inactive state
  ...(!active && {
    backgroundColor: "transparent",
    color: "#1f2937",
    borderColor: "#e2e8f0",
    "&:hover": {
      backgroundColor: "#f3f4f6",
      borderColor: "#6366f1",
      transform: "translateY(-1px)",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    },
    "& .MuiSvgIcon-root": {
      color: "#6b7280",
    },
    "& .mode-description": {
      color: "#6b7280",
    },
  }),

  // Disabled state
  ...(disabled && {
    opacity: 0.5,
    cursor: "not-allowed",
    pointerEvents: "none",
    "&:hover": {
      transform: "none",
      boxShadow: "none",
      borderColor: "#e2e8f0",
    },
  }),
}));

const ModernSummarizer = () => {
  const userDetails = useSelector((user) => user);
  // const userID = userDetails?.currentUser?._id || "";
  const token = sessionStorage.getItem("token");

  const getUserIdentity = () => {
    const token =
      sessionStorage.getItem("token") || localStorage.getItem("token");

    if (!token) return null;

    try {
      const decoded = jwtDecode(token);
      console.log("🔓 DECODED TOKEN:", decoded);
      // 🟡 GUEST
      if (decoded.role === "guest" || decoded.authType === "guest") {
        console.log("🟡 Guest detected → machineId:", decoded.machineId);
        return {
          machineId: decoded.machineId,
        };
      }

      // 🟢 LOGIN USER
      if (decoded._id) {
        return {
          userId: decoded._id,
        };
      }

      return null;
    } catch (err) {
      console.error("Invalid token");
      return null;
    }
  };

  const [loading, setLoading] = useState(false);
  const [editorState1, setEditorState1] = useState(() =>
    EditorState.createEmpty(),
  );
  const [textLength1, setTextLength1] = useState();
  const history = useHistory();
  const [editorStatePara, setEditorStatePara] = useState("");
  const [paragraphState, setParagraphState] = useState();
  const [selectedButtons, setSelectedButtons] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const [totalWords, setTotalWords] = useState(0);
  const [totalWords2, setTotalWords2] = useState(0);
  const [activeLink, setActiveLink] = useState(null);
  const [APIData, setAPIData] = useState(false);
  const [sliderValue, setSliderValue] = useState(0);
  const [sliderText, setSliderText] = useState("Shorten");
  const [keywords, setKeywords] = useState([]);
  const [selectedKeywords, setSelectedKeywords] = useState();
  const [isBulletPoints, setIsBulletPoints] = useState(false);
  const [noOfBullets, setNoOfBullets] = useState(0);
  const [isParagraph, setIsParagraph] = useState(false);
  const [isCustom, setIsCustom] = useState(false);
  const [customPrompt, setCustomPrompt] = useState("");
  const [isKeyword, setIsKeyword] = useState(false);
  const [maxCountDisplayed, setMaxCountDisplayed] = useState(false);
  const [isSummarize, setIsSummarize] = useState(false);

  // Updated speech recognition refs - removed react-speech-recognition dependency
  const recognitionRef = useRef(null);
  const [transcriptBuffer, setTranscriptBuffer] = useState("");
  const [isRecording, setIsRecording] = useState(false);

  const [isContinuousListening, setIsContinuousListening] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [inputKey, setInputKey] = useState();
  const [showSuccess, setShowSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [noOfParagraphs, setNoOfParagraphs] = useState(0);
  const [customModeText, setCustomModeText] = useState("");

  // State for word limit warning dialog
  const [wordLimitDialogOpen, setWordLimitDialogOpen] = useState(false);
  const [wordLimitExceeded, setWordLimitExceeded] = useState(false);

  // Access control hooks
  const accessToUpload = useCheckFeatureAccess("summarizer", "upload");
  const accessToSummarise = useCheckFeatureAccess("summarizer", "summarizer");
  const accessToSummarizerScreen = useCheckSubscriptionPlanAccess("Summarizer");
  const [subReqOpen, setSubReqOpen] = useState(false);
  const [isFeatureInside, setIsFeatureInside] = useState(false);

  const accessTocustom = useCheckSubscriptionPlanAccess("custom");
  const accessToMic = useCheckSubscriptionPlanAccess("mic");

  useEffect(() => {
    if (accessToSummarizerScreen == false) {
      setSubReqOpen(true);
    }
  }, [accessToSummarizerScreen]);

  const { hasCommandModifier } = KeyBindingUtil;
  let [keyCode, setKeyCode] = useState(null);
  const sliderMarks = [
    { value: 0, label: "0%" },
    { value: 20, label: "20%" },
    { value: 40, label: "40%" },
    { value: 60, label: "60%" },
    { value: 80, label: "80%" },
    { value: 100, label: "100%" },
  ];

  let maxWords = 1500;
  const [words, setWords] = useState([]);

  useEffect(() => {
    // Lock body scroll and remove layout spacing for full screen
    document.body.style.margin = "0";
    document.body.style.padding = "0";
    document.body.style.height = "100vh";
    document.body.style.overflow = "hidden";
    document.documentElement.style.height = "100vh";
    document.documentElement.style.overflow = "hidden";

    return () => {
      document.body.style.margin = "";
      document.body.style.padding = "";
      document.body.style.height = "";
      document.body.style.overflow = "auto";
      document.documentElement.style.height = "";
      document.documentElement.style.overflow = "auto";
    };
  }, []);

  // Dark mode state
  const [isDarkMode, setIsDarkMode] = useState(false);
  useEffect(() => {
    const updateTheme = () => {
      const theme = localStorage.getItem("ThemeSwitch");
      setIsDarkMode(theme === "true");
    };
    updateTheme();
    window.addEventListener("storage", updateTheme);
    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function (key, value) {
      originalSetItem.apply(this, arguments);
      if (key === "ThemeSwitch") {
        updateTheme();
      }
    };
    return () => {
      window.removeEventListener("storage", updateTheme);
      localStorage.setItem = originalSetItem;
    };
  }, []);

  // Initialize speech recognition
  useEffect(() => {
    const SpeechRecognitionAPI =
      window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!SpeechRecognitionAPI) {
      console.warn("Speech recognition is not supported in this browser.");
      return;
    }

    const recognition = new SpeechRecognitionAPI();

    recognition.continuous = true;
    recognition.interimResults = false;
    recognition.lang = "en-US";

    recognition.onresult = (event) => {
      const transcript = event.results[event.results.length - 1][0].transcript;
      setTranscriptBuffer((prev) => prev + " " + transcript);
    };

    recognition.onerror = (event) => {
      console.error("Speech recognition error:", event.error);
      if (event.error === "not-allowed") {
        toast.error(
          "Microphone access denied. Please allow microphone access.",
        );
      } else if (event.error === "no-speech") {
        toast.warn("No speech detected. Please try again.");
      }
      setIsRecording(false);
    };

    recognition.onend = () => {
      if (isRecording) {
        // Process any remaining transcript buffer
        if (transcriptBuffer.trim()) {
          handleSpeechInput(transcriptBuffer);
        }
        setTranscriptBuffer("");
        setIsRecording(false);
      }
    };

    recognitionRef.current = recognition;

    return () => {
      if (recognitionRef.current) {
        try {
          recognitionRef.current.stop();
        } catch (e) {
          // Ignore stop errors on unmount
        }
      }
    };
  }, []);

  // Process transcript buffer when it changes
  useEffect(() => {
    if (transcriptBuffer && !isRecording) {
      handleSpeechInput(transcriptBuffer);
    }
  }, [transcriptBuffer, isRecording]);

  // Decorator for highlighting
  const Decorated = ({ children }) => {
    return <span style={{ color: "darkorange" }}>{children}</span>;
  };

  function findWithRegex(words, contentBlock, callback) {
    const text = contentBlock.getText();
    words.forEach((word) => {
      const matches = [...text.matchAll(word)];
      matches.forEach((match) =>
        callback(match.index, match.index + match[0].length),
      );
    });
  }

  function handleStrategy(contentBlock, callback) {
    findWithRegex(words, contentBlock, callback);
  }

  const createDecorator = () => {
    return new CompositeDecorator([
      {
        strategy: handleStrategy,
        component: Decorated,
      },
    ]);
  };

  const [editorState2, setEditorState2] = useState(
    EditorState.createEmpty(new CompositeDecorator([])),
  );
  const [originalText, setOriginalText] = useState("");
  const [paraphrasedText, setParaphrasedText] = useState("");
  const editor = useRef(null);

  function focusEditor() {
    editor.current.focus();
  }

  const highlightDecorator = (newWords) => {
    return new CompositeDecorator([
      {
        strategy: (contentBlock, callback) => {
          const text = contentBlock.getText();
          newWords.forEach((newWord) => {
            const escapedNewWord = newWord.replace(
              /[.*+?^${}()|[\]\\]/g,
              "\\$&",
            );
            const regex = new RegExp(
              `(?:^|\\W)${escapedNewWord}(?:\\W|$)`,
              "gi",
            );
            let match;
            while ((match = regex.exec(text)) !== null) {
              const startIndex = match.index;
              const endIndex = startIndex + match[0].length;
              callback(startIndex, endIndex);
            }
          });
        },
        component: Decorated,
      },
    ]);
  };

  const handleBreadcrumbClick = (event, path) => {
    event.preventDefault();
    window.location.href = "/docTags";
    // history.push(path);
  };

  const changeColors = () => {
    const originalTokens = originalText.split(/\s+/);
    const paraphrasedTokens = paraphrasedText.split(/\s+/);
    const newWords = paraphrasedTokens.filter(
      (word) => !originalTokens.includes(word),
    );
    const dec = highlightDecorator(newWords);
    const contentState = ContentState.createFromText(paraphrasedText);
    setEditorState2(EditorState.createWithContent(contentState, dec));
  };

  useEffect(() => {
    if (paraphrasedText !== "") {
      changeColors();
    }
  }, [paraphrasedText]);

  useEffect(() => {
    if (undefined !== selectedKeywords) {
      summarizeByKeyWord();
    }
  }, [selectedKeywords]);

  const handleWordCountExceed = () => {
    if (!maxCountDisplayed) {
      toast.warn("Word count exceeded than 1500");
      setMaxCountDisplayed(true);
    }
  };

  // UPDATED MIC FUNCTIONALITY
  const handleMicClick = () => {
    if (accessToMic == false) {
      setSubReqOpen(true);
      setIsFeatureInside(true);
      return;
    }

    if (!recognitionRef.current) {
      toast.error("Speech recognition is not supported by your browser.");
      return;
    }

    if (isRecording) {
      // Stop recording
      try {
        recognitionRef.current.stop();
      } catch (error) {
        console.error("Error stopping speech recognition:", error);
      }
      setIsRecording(false);
    } else {
      // Start recording
      try {
        setTranscriptBuffer(""); // Clear buffer
        recognitionRef.current.start();
        setIsRecording(true);
        toast.info("Listening... Speak now");
      } catch (error) {
        console.error("Error starting speech recognition:", error);
        toast.error("Failed to start speech recognition. Please try again.");
      }
    }
  };

  const handleSpeechInput = (input) => {
    if (input.trim() !== "") {
      // Get current text from editor
      const currentText = editorState1.getCurrentContent().getPlainText();

      // Add space if content exists
      const separator = currentText && !currentText.endsWith(" ") ? " " : "";

      // Create new text with speech input
      const newText = `${currentText}${separator}${input}`;

      // Create new content state
      const newContentState = ContentState.createFromText(newText);

      // Create new editor state
      const newEditorState = EditorState.createWithContent(newContentState);

      // Update editor state
      setEditorState1(newEditorState);

      toast.success("Speech added to editor");
    }
  };

  useEffect(() => {
    return () => {
      if (recognitionRef.current) {
        try {
          recognitionRef.current.stop();
        } catch (e) {
          // Ignore stop errors
        }
      }
    };
  }, []);

  useEffect(() => {
    if (isCustom) {
      if (customPrompt == "") {
        setIsSummarize(true);
      } else {
        setIsSummarize(false);
      }
    }
  }, [customPrompt]);

  useEffect(() => {
    if (isCustom == false) {
      setIsSummarize(false);
    }
  }, [isCustom]);

  useEffect(() => {
    updateWordCount();
  }, [editorState1]);

  useEffect(() => {
    updateWordCount2();
  }, [editorState2]);

  const updateWordCount = () => {
    let contentState = editorState1.getCurrentContent();
    let hasText = contentState.hasText();
    if (hasText) {
      let currentText = contentState.getPlainText();
      let wordCount = currentText.trim().split(/\s+/).length;
      setTotalWords(wordCount);
    } else {
      setTotalWords(0);
    }
  };

  const countWords = (editorState) => {
    const contentState = editorState.getCurrentContent();
    const rawText = convertToRaw(contentState)
      .blocks.map((block) => block.text.trim())
      .join(" ")
      .trim();
    return rawText.length > 0 ? rawText.split(/\s+/).length : 0;
  };

  const wordCountEditor1 = countWords(editorState1);

  const updateWordCount2 = () => {
    let contentState = editorState2.getCurrentContent();
    let hasText = contentState.hasText();
    if (hasText) {
      let currentText = contentState.getPlainText();
      let wordCount = currentText.trim().split(/\s+/).length;
      setTotalWords2(wordCount);
    } else {
      setTotalWords2(0);
    }
  };

  // Function to count paragraphs
  const countParagraphs = (text) => {
    if (!text || text.trim() === "") return 0;

    const paragraphs = text
      .split(/\n\s*\n/)
      .filter((para) => para.trim() !== "");

    if (paragraphs.length === 0) {
      const lines = text.split("\n").filter((line) => line.trim() !== "");
      return lines.length > 0 ? 1 : 0;
    }

    return paragraphs.length;
  };

  // Check if output has content
  const hasOutputContent = () => {
    return editorState2.getCurrentContent().hasText();
  };

  const handleKeyWords = async (e) => {
    // const checkailimit = await checkAIRequestLimit(getUserIdentity());
    // if (checkailimit == false) {
    //   toast.warn("AI request limit reached.");
    //   return;
    // }
    let value = e.target.value;
    setSelectedKeywords(value);
  };

  const handleDeleteClick = () => {
    setEditorState1(EditorState.createEmpty());
    setEditorState2(EditorState.createEmpty());
    setEditorStatePara("");
    setTotalWords(0);
    setTotalWords2(0);
    setSliderValue(0);
    setSliderText("Shorten");
    setIsCustom(false);
    setIsVisible(false);
    setMaxCountDisplayed(false);
    setTranscriptBuffer(""); // Clear transcript buffer
    setNoOfParagraphs(0);
    setActiveLink(null);
    setCustomModeText("");
    setSuccessMessage("Content cleared successfully!");
    setShowSuccess(true);
  };

  const handleDeleteClick2 = () => {
    setEditorState2(EditorState.createEmpty());
    setEditorStatePara("");
    setTotalWords2(0);
    setSliderValue(0);
    setSliderText("Shorten");
    setIsCustom(false);
    setActiveLink(null);
    setCustomPrompt("");
    setCustomModeText("");
    setMaxCountDisplayed(false);
    setTranscriptBuffer(""); // Clear transcript buffer
    setIsBulletPoints(false);
    setNoOfParagraphs(0);
    setIsVisible(false);
    setSuccessMessage("Output cleared successfully!");
    setShowSuccess(true);
  };

  const summarizeByKeyWord = async () => {
    setLoading(true);
    let plainText;
    const selection = editorState1.getSelection();
    plainText = editorState1
      .getCurrentContent()
      .getBlockForKey(selection.getAnchorKey())
      .getText()
      .slice(selection.getStartOffset(), selection.getEndOffset());

    if (!plainText) {
      plainText = editorState1.getCurrentContent().getPlainText();
    }

    let sendData = {
      text: selectedKeywords,
      content: plainText,
      prompts: "three",
      // userId: userID,
      ...getUserIdentity(),
      isCoAuthor: false,
    };

    try {
      let response = await getCheckSummariser(sendData);
      if (response.data.output[0].startsWith("\n")) {
        response.data.output[0] = response.data.output[0].substring(1);
      }
      const summaryText = response.data.output.join("\n");
      const newContentState = ContentState.createFromText(summaryText);
      let newEditorState = EditorState.createWithContent(newContentState);
      setEditorState2(newEditorState);
      setActiveLink("paragraph");
      setEditorStatePara(newEditorState.getCurrentContent().getPlainText());

      const paragraphCount = countParagraphs(summaryText);
      setNoOfParagraphs(paragraphCount);

      const identity = getUserIdentity();

      if (identity) {
        await addUserLogs({
          ...identity,
          actionType: "summariser",
        });
      }
    } catch (e) {
      console.log("summarizeByKeyWorderror", e);
      setActiveLink(null);
    }
    setLoading(false);
  };

  const summarizeByPercentage = async (value) => {
    let promptValue = "four";
    let newValue;
    if (value == 0) {
      handleSummeriseClick(false);
      return;
    } else if (value < 60) {
      newValue = 100 - value;
      promptValue = "four";
    } else if (value == 60) {
      newValue = 40;
      promptValue = "five";
    } else if (value > 60) {
      newValue = value;
      promptValue = "five";
    }

    let plainText;
    const selection = editorState1.getSelection();
    plainText = editorState1
      .getCurrentContent()
      .getBlockForKey(selection.getAnchorKey())
      .getText()
      .slice(selection.getStartOffset(), selection.getEndOffset());

    if (!plainText) {
      plainText = editorState1.getCurrentContent().getPlainText();
    }

    let sendData = {
      text: newValue.toString() + "%",
      content: plainText,
      prompts: promptValue,
      ...getUserIdentity(),
      // userId: userID,
      isCoAuthor: false,
    };

    setLoading(true);
    try {
      let response = await getCheckSummariser(sendData);
      if (response.data.output[0].startsWith("\n")) {
        response.data.output[0] = response.data.output[0].substring(1);
      }
      const summaryText = response.data.output.join("\n");
      const newContentState = ContentState.createFromText(summaryText);
      let newEditorState = EditorState.createWithContent(newContentState);
      setEditorState2(newEditorState);
      setActiveLink("paragraph");
      setEditorStatePara(newEditorState.getCurrentContent().getPlainText());

      const paragraphCount = countParagraphs(summaryText);
      setNoOfParagraphs(paragraphCount);
      const identity = getUserIdentity();

      if (identity) {
        await addUserLogs({
          ...identity,
          actionType: "summariser",
        });
      }
    } catch (e) {
      setActiveLink(null);
      console.log("summarizeByPercentageerror", e);
    }
    setLoading(false);
  };

  const handleCopyEditor1 = () => {
    let sentence = editorState1.getCurrentContent().getPlainText();
    if (sentence == "") {
      toast.warn(`You don't have text, to copy`);
      return;
    }
    navigator.clipboard.writeText(sentence).then(
      function () {
        setSuccessMessage("Text copied successfully!");
        setShowSuccess(true);
      },
      function (err) {
        console.error("Async: Could not copy text: ", err);
      },
    );
  };

  const handleCopyEditor2 = () => {
    let sentence = editorState2.getCurrentContent().getPlainText();
    if (sentence == "") {
      toast.warn(`You don't have text, to copy`);
      return;
    }
    navigator.clipboard.writeText(sentence).then(
      function () {
        setSuccessMessage("Summary copied successfully!");
        setShowSuccess(true);
      },
      function (err) {
        console.error("Async: Could not copy text: ", err);
      },
    );
  };

  const handleDownload = () => {
    if (!editorState2.getCurrentContent().getPlainText()) {
      toast.warn(`You don't have text, to download`);
      return;
    }
    const blob = new Blob([editorState2.getCurrentContent().getPlainText()], {
      type: "text/plain",
    });
    const anchor = document.createElement("a");
    anchor.href = URL.createObjectURL(blob);
    anchor.download = "text_content.txt";
    anchor.click();
    URL.revokeObjectURL(anchor.href);
    setSuccessMessage("File downloaded successfully!");
    setShowSuccess(true);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.type === "application/pdf") {
      toast.warn("PDF format is not supported.");
      return;
    }

    if (file.size > 4194304) {
      Swal.fire({
        title: "Document exceeded the limit of 4 Mb!",
        icon: "error",
        confirmButtonText: "ok",
      });
      return;
    }

    if (
      file.type ===
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ) {
      let reader = new FileReader();
      reader.onload = function (event) {
        mammoth
          .convertToHtml({ arrayBuffer: event.target.result })
          .then(function (result) {
            const contentState = stateFromHTML(result.value);
            setEditorState1(EditorState.createWithContent(contentState));
            setSuccessMessage("File uploaded successfully!");
            setShowSuccess(true);
          })
          .done();
      };
      reader.readAsArrayBuffer(file);
    } else if (file.type === "text/plain") {
      let reader = new FileReader();
      reader.onload = function (event) {
        const contentState = ContentState.createFromText(event.target.result);
        setEditorState1(EditorState.createWithContent(contentState));
        setSuccessMessage("File uploaded successfully!");
        setShowSuccess(true);
      };
      reader.readAsText(file);
    } else {
      toast.info(
        "Your file format is not supported, Please upload txt or doc files.",
      );
    }
  };

  const handleParaphrase = async () => {
    setActiveLink("paragraph");
    setAPIData(false);
    setIsBulletPoints(false);
    setIsParagraph(true);
    setIsCustom(false);
    setIsKeyword(true);
    GrammerCheckForParaphrase();
  };

  const handleCustomPrompt = (e) => {
    let value = e.target.value;
    setCustomPrompt(value);
  };

  const GrammerCheckForParaphrase = async (type) => {
    let plainText;
    const selection = editorState2.getSelection();
    plainText = editorState2
      .getCurrentContent()
      .getBlockForKey(selection.getAnchorKey())
      .getText()
      .slice(selection.getStartOffset(), selection.getEndOffset());

    if (!plainText) {
      plainText = editorState2.getCurrentContent().getPlainText();
    }

    let data = {
      text: plainText,
      tone: "defaultPrompt",
      ...getUserIdentity(),
      // userId: userID,
      isCoAuthor: false,
    };

    setLoading(true);
    try {
      let paraphraseResponse = await checkPhrasing(data);
      if (paraphraseResponse.data !== "") {
        if (paraphraseResponse.data.output[0].startsWith("\n")) {
          paraphraseResponse.data.output[0] =
            paraphraseResponse.data.output[0].substring(1);
        }
        const summaryText = paraphraseResponse.data.output.join("\n");
        let responseOutput = ContentState.createFromText(summaryText);
        let newEditorState = EditorState.createWithContent(responseOutput);
        setEditorState2(newEditorState);
        handleReplaceText(newEditorState);
        setEditorStatePara(newEditorState.getCurrentContent().getPlainText());

        const paragraphCount = countParagraphs(summaryText);
        setNoOfParagraphs(paragraphCount);

        const identity = getUserIdentity();

        if (identity) {
          await addUserLogs({
            ...identity,
            actionType: "paraphrase",
          });
        }
      }
    } catch (e) {
      console.log("error", e);
    }
    setLoading(false);
  };

  const handleReplaceText = (newEditorState) => {
    let newState = newEditorState.getCurrentContent();
    let newText = newState.getPlainText();
    let previousState = editorState2.getCurrentContent();
    let previousText = previousState.getPlainText();
    const replacedContentState = ContentState.createFromText(newText);
    setOriginalText(previousText);
    setParaphrasedText(newText);
  };

  const handleParagraph = () => {
    const contentState = ContentState.createFromText(editorStatePara);
    const editorStateWithText = EditorState.createWithContent(contentState);
    setEditorState2(editorStateWithText);

    const paragraphCount = countParagraphs(editorStatePara);
    setNoOfParagraphs(paragraphCount);

    return;
  };

  const handleLinkClick = (linkType) => {
    setActiveLink(linkType);

    // Reset all states first
    setIsBulletPoints(false);
    setIsParagraph(false);
    setIsCustom(false);
    setCustomPrompt("");
    setIsKeyword(false);

    if (linkType === "bullets") {
      setAPIData(true);
      setIsBulletPoints(true);
      handleApplyBullets();
    } else if (linkType === "paragraph") {
      setAPIData(false);
      setIsParagraph(true);
      setIsKeyword(true);
      handleParagraph();
    } else if (linkType === "custom") {
      setIsCustom(true);
      setIsSummarize(true);
      setCustomModeText("Enter custom instructions...");
    }
  };

  const handleCustomModeApply = () => {
    if (accessTocustom == false) {
      setSubReqOpen(true);
      setIsFeatureInside(true);
      return;
    }

    if (customPrompt.trim() !== "") {
      handleSummeriseClick(false);
      setCustomModeText(
        `Custom: ${customPrompt.substring(0, 30)}${customPrompt.length > 30 ? "..." : ""}`,
      );
    }
  };

  const handleEditorChange = (newEditorState) => {
    const contentState = newEditorState.getCurrentContent();
    const currentText = contentState.getPlainText();
    let hasText = contentState.hasText();
    const wordCount = currentText.split(/\s+/).length;
    setEditorState1(newEditorState);
    setMaxCountDisplayed(false);
    setTotalWords(hasText ? wordCount : 0);
  };

  const handleEditorChange2 = (newEditorState) => {
    const contentState = newEditorState.getCurrentContent();
    const currentText = contentState.getPlainText();
    const wordCount = currentText.split(/\s+/).length;

    let lines = currentText.split("\n").filter((line) => line.trim() !== "");
    let textWithoutEmptyLines = lines.join("\n");
    const sentenceSplitPattern = /(?<!\b(?:[A-Z][a-z]*\.?\s?)+)\.\s+/;
    let sentences = textWithoutEmptyLines
      .split(sentenceSplitPattern)
      .filter((sentence) => sentence.trim() !== "")
      .map((sentence) => sentence.replace(/\n/g, ""));

    let hasText = contentState.hasText();
    if (wordCount > maxWords) {
      handleWordCountExceed();
      return;
    }

    setNoOfBullets(sentences.length);
    setTotalWords2(hasText ? wordCount : 0);
    setEditorState2(newEditorState);
    setMaxCountDisplayed(false);

    if (isParagraph) {
      const paragraphCount = countParagraphs(currentText);
      setNoOfParagraphs(paragraphCount);
    }

    if (hasText && !isVisible) {
      setIsVisible(true);
    } else if (!hasText && isVisible) {
      setIsVisible(false);
    }
  };

  // Updated handleSummeriseClick with word limit check
  const handleSummeriseClick = async (isDefault) => {
    // Check if word count exceeds limit
    const wordCount = editorState1
      .getCurrentContent()
      .getPlainText()
      .split(/\s+/).length;

    if (wordCount > 1500) {
      setWordLimitDialogOpen(true);
      setWordLimitExceeded(true);
      return;
    }

    setLoading(true);
    try {
      if (
        editorState1.getCurrentContent().getPlainText().split(/\s+/).length -
          1 ==
        0
      ) {
        toast.warn("Please enter text");
        return;
      } else {
        const contentState = editorState1.getCurrentContent();
        let plainText;
        const selection = editorState1.getSelection();
        plainText = editorState1
          .getCurrentContent()
          .getBlockForKey(selection.getAnchorKey())
          .getText()
          .slice(selection.getStartOffset(), selection.getEndOffset());

        if (!plainText) {
          plainText = contentState.getPlainText();
        }

        let sendData = {
          text: plainText,
          content: "",
          prompts: isDefault ? "one" : "seven",
          ...getUserIdentity(),
          // userId: userID,
          isCoAuthor: false,
        };

        if (customPrompt !== "") {
          sendData = {
            text: customPrompt,
            content: plainText,
            prompts: "six",
            ...getUserIdentity(),
            // userId: userID,
            isCoAuthor: false,
          };
        }

        setLoading(true);
        let generateSummary = await getCheckSummariser(sendData);
        if (generateSummary.data.output[0].startsWith("\n")) {
          generateSummary.data.output[0] =
            generateSummary.data.output[0].substring(1);
        }
        const summaryText = generateSummary.data.output.join("\n");
        const newContentState = ContentState.createFromText(summaryText);
        const newEditorState = EditorState.createWithContent(newContentState);
        setEditorState2(newEditorState);
        setActiveLink("paragraph");
        setEditorStatePara(newEditorState.getCurrentContent().getPlainText());

        // Update paragraph count
        const paragraphCount = countParagraphs(summaryText);
        setNoOfParagraphs(paragraphCount);

        let sendData2 = {
          text: plainText,
          prompts: "two",
          ...getUserIdentity(),
          // userId: userID,
          isCoAuthor: false,
        };

        let generateKeywords = await getCheckSummariser(sendData2);
        let text = generateKeywords.data.output[0];

        let allkeywords = text
          .split(/\n/)
          .map((line) => line.trim())
          .filter((line) => line.length > 0)
          .map((line) => line.replace(/^[\d.-\s]*/, ""));

        let formattedKeywords = allkeywords.map((keyword) => ({
          name: keyword,
          value: keyword,
        }));

        setKeywords(formattedKeywords);
        setIsVisible(true);
        setIsKeyword(isCustom ? false : true);
        const identity = getUserIdentity();

        if (identity) {
          await addUserLogs({
            ...identity,
            actionType: "summariser",
          });
        }
      }
    } catch (error) {
      console.error("summarizeClick", error);
      toast.error("Error Occurred");
    }
    setLoading(false);
  };

  const handleApplyBullets = () => {
    let hasText = editorState2.getCurrentContent().hasText();
    if (!hasText) {
      toast.info("No content to add bullets");
      return;
    }
    setIsBulletPoints(true);
    setIsParagraph(false);
    setIsCustom(false);
    setIsKeyword(true);

    let text = editorState2.getCurrentContent().getPlainText();

    let lines = text.split("\n").filter((line) => line.trim() !== "");
    let textWithoutEmptyLines = lines.join("\n");

    const sentenceSplitPattern = /(?<!\b(?:[A-Z][a-z]*\.?\s?)+)\.\s+/;
    let sentences = textWithoutEmptyLines
      .split(sentenceSplitPattern)
      .filter((sentence) => sentence.trim() !== "")
      .map((sentence) => sentence.replace(/\n/g, ""));
    setNoOfBullets(sentences.length);

    let formattedText = sentences.join(".\n");
    let newContent = ContentState.createFromText(formattedText);
    let newEditorState = EditorState.createWithContent(newContent);
    let newEditorStateExt = newEditorState.getCurrentContent();
    let firstBlock = newEditorStateExt.getFirstBlock();
    let lastBlock = newEditorStateExt.getLastBlock();
    let firstBlockKey = firstBlock.getKey();
    let lastBlockKey = lastBlock.getKey();
    let firstBlockLength = firstBlock.getLength();
    let lastBlockLength = lastBlock.getLength();
    let selection = newEditorState.getSelection().merge({
      anchorKey: firstBlockKey,
      anchorOffset: 0,
      focusKey: lastBlockKey,
      focusOffset: lastBlockLength,
    });
    let selectedState = EditorState.forceSelection(newEditorState, selection);
    setParagraphState(selectedState);

    let newEditorState2 = RichUtils.toggleBlockType(
      selectedState,
      "unordered-list-item",
    );
    setEditorState2(newEditorState2);
  };

  const handleSliderChange = async (event, newValue) => {
    const percentage = ((newValue - 0) / (100 - 0)) * 100;
    setSliderValue(newValue);
    setSliderText(newValue >= 60 ? "Expand" : "Shorten");
    summarizeByPercentage(newValue);
  };

  // Handle word limit dialog close
  const handleWordLimitDialogClose = () => {
    setWordLimitDialogOpen(false);
    setWordLimitExceeded(false);
  };

  // Update windowWidth on resize
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const modes = [
    {
      id: "paragraph",
      label: "Paragraph",
      icon: DocumentIcon,
      description: "Traditional paragraph format",
    },
    {
      id: "bullets",
      label: "Bullet Points",
      icon: BulletIcon,
      description: "Convert to bullet points",
    },
  ];

  return (
    <>
      <SubscriptionRequired
        open={subReqOpen}
        setOpen={setSubReqOpen}
        isFeatureInside={isFeatureInside}
        setIsFeatureInside={setIsFeatureInside}
        path={"Summarizer"}
      />

      {/* Word Limit Warning Dialog */}
      <Dialog
        open={wordLimitDialogOpen}
        onClose={handleWordLimitDialogClose}
        aria-labelledby="word-limit-dialog-title"
        aria-describedby="word-limit-dialog-description"
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: 3,
            padding: 2,
            minWidth: 400,
            background: isDarkMode ? "#1e293b" : "#ffffff",
            color: isDarkMode ? "#ffffff" : "#000000",
          },
        }}
      >
        <DialogTitle
          id="word-limit-dialog-title"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            color: "#ef4444",
            fontWeight: 600,
          }}
        >
          <WarningIcon sx={{ fontSize: 28 }} />
          Word Limit Exceeded
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="word-limit-dialog-description"
            sx={{
              color: isDarkMode ? "#94a3b8" : "#4b5563",
              fontSize: "1rem",
            }}
          >
            You have entered <strong>{wordCountEditor1}</strong> words, which
            exceeds the maximum limit of <strong>1500 words</strong>.
          </DialogContentText>
          <Box
            sx={{
              mt: 2,
              p: 2,
              bgcolor: isDarkMode ? "#334155" : "#f3f4f6",
              borderRadius: 2,
            }}
          >
            <Typography
              variant="body2"
              sx={{ color: isDarkMode ? "#e2e8f0" : "#1f2937" }}
            >
              Please reduce your text to 1500 words or less to continue.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 0 }}>
          <Button
            onClick={handleWordLimitDialogClose}
            variant="contained"
            sx={{
              bgcolor: "#ef4444",
              "&:hover": {
                bgcolor: "#dc2626",
              },
              borderRadius: 2,
              px: 4,
            }}
          >
            OK, Got it
          </Button>
        </DialogActions>
      </Dialog>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          overflow: "hidden",
          background: isDarkMode
            ? "linear-gradient(135deg, #000000 0%, #000000 100%)"
            : "linear-gradient(135deg, #ffffffff 0%, #d3d1d1ff)",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Container
          maxWidth={false}
          disableGutters
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: "100%",
            px: 2,
            py: 1.5,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              position: "relative",
              width: "100%",
              mb: 1.5,
              flexShrink: 0,
            }}
          >
            {/* LEFT SIDE - Breadcrumb */}
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Paper
                elevation={1}
                sx={{
                  p: 1.5,
                  bgcolor: "white",
                  borderRadius: 3,
                  border: "1px solid",
                  borderColor: "divider",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    boxShadow: "0 4px 12px rgba(102, 126, 234, 0.15)",
                  },
                }}
              >
                <Breadcrumbs
                  separator={
                    <NavigateNextIcon
                      fontSize="small"
                      sx={{ color: "#667eea" }}
                    />
                  }
                  aria-label="breadcrumb"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "nowrap",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Box
                      sx={{
                        bgcolor: "white",
                        borderRadius: 2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 32,
                        height: 32,
                        mr: 2,
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      }}
                    >
                      <img
                        alt="logo"
                        src={Poetlogopen}
                        style={{
                          height: "28px",
                          width: "28px",
                          objectFit: "contain",
                          bgcolor: "white",
                          // filter: "drop-shadow(0 0 7px rgba(93, 0, 255, 0.65))",
                          filter:
                            "drop-shadow(0 0 7px rgba(163, 163, 164, 0.65))",
                        }}
                      />
                    </Box>
                    <AutoFixHigh sx={{ fontSize: 20, color: "#667eea" }} />

                    <Link
                      to="/docTags"
                      onClick={(e) => handleBreadcrumbClick(e, "/docTags")}
                      style={{
                        textDecoration: "none",
                        color: "#667eea",
                        fontWeight: 500,
                        fontSize: "0.95rem",
                        padding: "4px 8px",
                        borderRadius: "6px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      MultiTool AI
                    </Link>

                    <NavigateNextIcon
                      fontSize="small"
                      sx={{ color: "#667eea" }}
                    />

                    <Typography
                      sx={{
                        color: "#1a1a1a",
                        fontWeight: 600,
                        fontSize: "0.95rem",
                        padding: "4px 8px",
                        borderRadius: "6px",
                        backgroundColor: "rgba(102, 126, 234, 0.08)",
                        whiteSpace: "nowrap",
                      }}
                    >
                      AI Summarizer
                    </Typography>
                  </Box>
                </Breadcrumbs>
              </Paper>
            </Box>

            {/* CENTER CONTENT */}
            <Box
              sx={{
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
                textAlign: "center",
              }}
            >
              <Typography
                sx={{
                  fontSize: 22,
                  fontWeight: 700,
                  color: "primary.main",
                }}
              >
                AI Summarizer
              </Typography>

              <Typography
                variant="caption"
                sx={{
                  color: "text.secondary",
                  fontStyle: "italic",
                }}
              >
                Transform your text with intelligent summarization
              </Typography>
            </Box>
          </Box>

          {/* Mode Selection - Redesigned */}
          <Card
            sx={{
              mb: 1.5,
              borderRadius: 4,
              background: isDarkMode
                ? "rgba(30, 41, 59, 0.95)"
                : "rgba(255,255,255,0.95)",
              backdropFilter: "blur(10px)",
              boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
              border: isDarkMode ? "1px solid #475569" : "1px solid #e2e8f0",
              flexShrink: 0,
            }}
          >
            <CardContent sx={{ p: 1 }}>
              <Grid2 container spacing={1} alignItems="center">
                <Grid2 item xs={12} md={8}>
                  <Box sx={{ mb: 1 }}>
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      sx={{
                        color: isDarkMode ? "white" : "text.primary",
                      }}
                    >
                      Output Format
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{
                        color: isDarkMode ? "#94a3b8" : "text.primary",
                      }}
                    >
                      Select how you want to display the summarized content
                    </Typography>
                  </Box>

                  <Grid2 container spacing={2}>
                    {modes.map((mode) => {
                      const IconComponent = mode.icon;
                      const isActive = activeLink === mode.id;
                      const isDisabled =
                        mode.id === "custom" && !hasOutputContent()
                          ? false
                          : !hasOutputContent();

                      return (
                        <Grid2 item xs={12} sm={4} key={mode.id}>
                          <ModeButton
                            fullWidth
                            active={isActive}
                            disabled={isDisabled}
                            onClick={() => handleLinkClick(mode.id)}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <IconComponent
                                className="mode-description"
                                sx={{
                                  fontSize: 20,
                                  color: isActive ? "black" : "black",
                                }}
                              />

                              <Typography
                                variant="caption"
                                className="mode-description"
                                sx={{
                                  color: isActive ? "black" : "black",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {mode.description}
                              </Typography>
                            </Box>
                          </ModeButton>
                        </Grid2>
                      );
                    })}
                  </Grid2>
                </Grid2>

                <Grid2 item xs={12} md={4}>
                  <Box
                    sx={{
                      p: 0.5,
                      borderRadius: 3,
                      bgcolor: isDarkMode
                        ? "rgba(255,255,255,0.05)"
                        : "rgba(0,0,0,0.02)",
                      border: `1px solid ${isDarkMode ? "#475569" : "#e2e8f0"}`,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                      }}
                    >
                      <TrendingDown
                        color={sliderValue >= 60 ? "secondary" : "primary"}
                      />
                      <Box sx={{ flex: 1 }}>
                        <Typography
                          variant="body2"
                          sx={{
                            color: isDarkMode ? "#94a3b8" : "text.primary",
                          }}
                        >
                          {sliderText} Text
                        </Typography>
                        <Slider
                          value={sliderValue}
                          onChange={handleSliderChange}
                          step={20}
                          marks={sliderMarks}
                          min={0}
                          max={100}
                          disabled={!hasOutputContent()}
                          sx={{
                            "& .MuiSlider-thumb": {
                              background:
                                sliderValue >= 60
                                  ? "linear-gradient(45deg, #f97316, #ea580c)"
                                  : "linear-gradient(45deg, #667eea, #764ba2)",
                              border: "3px solid white",
                              boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                            },
                            "& .MuiSlider-track": {
                              background:
                                sliderValue >= 60
                                  ? "linear-gradient(45deg, #f97316, #ea580c)"
                                  : "linear-gradient(45deg, #667eea, #764ba2)",
                            },
                          }}
                        />
                      </Box>
                      <TrendingUp
                        color={sliderValue >= 60 ? "primary" : "primary"}
                      />
                    </Box>
                    <Typography
                      variant="caption"
                      sx={{
                        display: "block",
                        textAlign: "center",
                        color: isDarkMode ? "#94a3b8" : "text.primary",
                      }}
                    >
                      Adjust length: {sliderValue}%
                    </Typography>
                  </Box>
                </Grid2>
              </Grid2>
            </CardContent>
          </Card>

          {/* Main Content - Takes remaining height */}
          <Box sx={{ flex: 1, minHeight: 0, width: "100%" }}>
            <Grid2 container spacing={2} sx={{ height: "100%" }}>
              {/* Input Panel */}
              <Grid2 item xs={12} lg={6} sx={{ height: "100%" }}>
                <StyledCard
                  sx={{
                    borderRadius: 4,
                    background: isDarkMode
                      ? "rgba(30, 41, 59, 0.95)"
                      : "rgba(255,255,255,0.95)",
                    backdropFilter: "blur(10px)",
                    boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
                    height: "100%",
                  }}
                >
                  {/* Input Header */}
                  <Box
                    sx={{
                      background: "linear-gradient(45deg, #667eea, #764ba2)",
                      color: "white",
                      p: 1,
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      position: "relative",
                      flexShrink: 0,
                    }}
                  >
                    <Avatar sx={{ bgcolor: "rgba(255,255,255,0.2)" }}>
                      <Create />
                    </Avatar>
                    <Box sx={{ flexGrow: 1 }}>
                      <Typography variant="h6" fontWeight={600}>
                        Input Text
                      </Typography>
                      <Typography variant="body2" sx={{ opacity: 0.9 }}>
                        Enter or upload your content
                      </Typography>
                    </Box>
                    <Badge
                      badgeContent={totalWords}
                      max={1500}
                      color={wordCountEditor1 > 1500 ? "error" : "warning"}
                    >
                      <Chip
                        label={`${wordCountEditor1}/1500`}
                        size="small"
                        sx={{
                          bgcolor:
                            wordCountEditor1 > 1500
                              ? "#ef4444"
                              : "rgba(255,255,255,0.2)",
                          color: "white",
                          fontWeight: 600,
                        }}
                      />
                    </Badge>
                  </Box>

                  {/* Editor */}
                  <CardContentScrollable>
                    <EditorContainer
                      sx={{
                        p: 2,
                        flex: 1,
                        minHeight: 0,
                        height: "100%",
                        overflow: "auto",
                        "& .DraftEditor-root": {
                          color: isDarkMode ? "white" : "inherit",
                          height: "100%",
                        },
                        "& .public-DraftEditor-content": {
                          height: "100%",
                        },
                        "& .public-DraftEditorPlaceholder-root": {
                          color: isDarkMode ? "#94a3b8" : "#999",
                        },
                      }}
                    >
                      <Editor
                        editorState={editorState1}
                        onChange={handleEditorChange}
                        placeholder="Start typing your text here, or use the upload button to add a document..."
                      />
                    </EditorContainer>
                  </CardContentScrollable>

                  {/* Action Bar */}
                  <Box
                    sx={{
                      p: 1,
                      background: isDarkMode
                        ? "linear-gradient(45deg, #334155, #475569)"
                        : "linear-gradient(45deg, #f8fafc, #e2e8f0)",
                      borderTop: isDarkMode
                        ? "1px solid #475569"
                        : "1px solid #e2e8f0",
                      flexShrink: 0,
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={1}
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Stack direction="row" spacing={1}>
                        <LightTooltip title="Voice Input">
                          <IconButton
                            onClick={handleMicClick}
                            disabled={!accessToSummarise}
                            sx={{
                              color: isRecording
                                ? "#ef4444"
                                : isDarkMode
                                  ? "#94a3b8"
                                  : "#6b7280",
                              animation: isRecording
                                ? "pulse 1s infinite"
                                : "none",
                            }}
                          >
                            {isRecording ? <Stop /> : <Mic />}
                          </IconButton>
                        </LightTooltip>
                        <LightTooltip title="Upload Document">
                          <IconButton
                            component="label"
                            disabled={!accessToUpload}
                            sx={{ color: isDarkMode ? "#94a3b8" : "#6366f1" }}
                          >
                            <CloudUpload />
                            <VisuallyHiddenInput
                              type="file"
                              key={inputKey}
                              onChange={handleFileChange}
                              accept=".txt,.doc,.docx"
                            />
                          </IconButton>
                        </LightTooltip>
                        <LightTooltip title="Clear All">
                          <IconButton
                            onClick={handleDeleteClick}
                            sx={{ color: "#ef4444" }}
                          >
                            <Delete />
                          </IconButton>
                        </LightTooltip>
                        <LightTooltip title="Copy Text">
                          <IconButton
                            onClick={handleCopyEditor1}
                            sx={{ color: "#10b981" }}
                          >
                            <ContentCopy />
                          </IconButton>
                        </LightTooltip>
                      </Stack>

                      <Button
                        variant="contained"
                        size="large"
                        onClick={() => handleSummeriseClick(true)}
                        startIcon={<MagicIcon />}
                        disabled={
                          loading ||
                          totalWords === 0 ||
                          isSummarize ||
                          !accessToSummarise
                        }
                        sx={{
                          background:
                            wordCountEditor1 > 1500
                              ? "#ef4444"
                              : "linear-gradient(45deg, #667eea, #764ba2)",
                          borderRadius: 3,
                          px: 3,
                          py: 1.5,
                          fontWeight: 600,
                          fontSize: "1.1rem",
                          boxShadow:
                            wordCountEditor1 > 1500
                              ? "0 4px 16px rgba(239,68,68,0.4)"
                              : "0 4px 16px rgba(102,126,234,0.4)",
                          "&:hover": {
                            transform: "translateY(-2px)",
                            boxShadow:
                              wordCountEditor1 > 1500
                                ? "0 8px 24px rgba(239,68,68,0.6)"
                                : "0 8px 24px rgba(102,126,234,0.6)",
                          },
                          transition: "all 0.3s ease",
                        }}
                      >
                        {loading ? "Processing..." : "Summarize"}
                      </Button>
                    </Stack>
                  </Box>
                </StyledCard>
              </Grid2>

              {/* Output Panel */}
              <Grid2 item xs={12} lg={6} sx={{ height: "100%" }}>
                <StyledCard
                  sx={{
                    borderRadius: 4,
                    height: "100%",
                    background: isDarkMode
                      ? "rgba(30, 41, 59, 0.95)"
                      : "rgba(255,255,255,0.95)",
                    backdropFilter: "blur(10px)",
                    boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
                  }}
                >
                  {/* HEADER */}
                  <Box
                    sx={{
                      background: "linear-gradient(45deg, #10b981, #059669)",
                      color: "white",
                      p: 1,
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      flexShrink: 0,
                    }}
                  >
                    <Avatar sx={{ bgcolor: "rgba(255,255,255,0.2)" }}>
                      <Analytics />
                    </Avatar>
                    <Box sx={{ flexGrow: 1 }}>
                      <Typography variant="h6" fontWeight={600}>
                        Generated Summary
                      </Typography>
                      <Typography variant="body2" sx={{ opacity: 0.9 }}>
                        {hasOutputContent()
                          ? "Processed content"
                          : "Processed content"}
                      </Typography>
                    </Box>
                    {hasOutputContent() && (
                      <Chip
                        label={`${totalWords2} ${totalWords2 === 1 ? "word" : "words"}`}
                        size="small"
                        sx={{
                          bgcolor: "rgba(255,255,255,0.2)",
                          color: "white",
                          fontWeight: 600,
                          "& .MuiChip-label": {
                            px: 2,
                          },
                        }}
                      />
                    )}
                  </Box>

                  {/* SCROLLABLE CONTENT */}
                  <Box
                    sx={{
                      flex: 1,
                      minHeight: 0,
                      overflow: "auto",
                      p: 2,
                      display: "flex",
                      flexDirection: "column",
                      color: isDarkMode ? "#94a3b8" : "#6b7280",
                      justifyContent: hasOutputContent()
                        ? "flex-start"
                        : "center",
                    }}
                  >
                    {!hasOutputContent() ? (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "100%",
                          minHeight: "300px",
                          width: "100%",
                          textAlign: "center",
                        }}
                      >
                        <Psychology
                          sx={{ fontSize: 64, mb: 2, opacity: 0.3 }}
                        />
                        <Typography variant="h6">Ready to Summarize</Typography>
                        <Typography
                          variant="body2"
                          textAlign="center"
                          sx={{ maxWidth: 300 }}
                        >
                          Enter your text and click summarize to see the magic
                          happen
                        </Typography>
                      </Box>
                    ) : (
                      <Editor
                        ref={editor}
                        editorState={editorState2}
                        onChange={handleEditorChange2}
                      />
                    )}
                  </Box>

                  {/* FOOTER */}
                  {hasOutputContent() && (
                    <Box
                      sx={{
                        p: 1,
                        borderTop: "1px solid",
                        borderColor: "divider",
                        flexShrink: 0,
                      }}
                    >
                      <Stack
                        direction="row"
                        spacing={1}
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Stack direction="row" spacing={1}>
                          <LightTooltip title="Clear Output">
                            <IconButton
                              onClick={handleDeleteClick2}
                              sx={{ color: "#ef4444" }}
                            >
                              <Delete />
                            </IconButton>
                          </LightTooltip>
                          <LightTooltip title="Copy Summary">
                            <IconButton
                              onClick={handleCopyEditor2}
                              sx={{ color: "#10b981" }}
                            >
                              <ContentCopy />
                            </IconButton>
                          </LightTooltip>
                          <LightTooltip title="Download">
                            <IconButton
                              onClick={handleDownload}
                              sx={{ color: "#3b82f6" }}
                            >
                              <Download />
                            </IconButton>
                          </LightTooltip>
                        </Stack>

                        <Button
                          variant="contained"
                          size="large"
                          onClick={handleParaphrase}
                          startIcon={<Transform />}
                          disabled={loading}
                          sx={{
                            background:
                              "linear-gradient(45deg, #10b981, #059669)",
                            borderRadius: 3,
                            px: 3,
                            py: 1.5,
                            fontWeight: 600,
                            fontSize: "1.1rem",
                            boxShadow: "0 4px 16px rgba(16,185,129,0.4)",
                            "&:hover": {
                              transform: "translateY(-2px)",
                              boxShadow: "0 8px 24px rgba(16,185,129,0.6)",
                            },
                            transition: "all 0.3s ease",
                          }}
                        >
                          Paraphrase
                        </Button>
                      </Stack>
                    </Box>
                  )}
                </StyledCard>
              </Grid2>
            </Grid2>
          </Box>

          {/* Loading Backdrop */}
          <Backdrop open={loading} sx={{ color: "#fff" }}>
            <Box sx={{ textAlign: "center" }}>
              <CircularProgress color="inherit" size={60} sx={{ mb: 2 }} />
              <Typography variant="h6">Processing your content...</Typography>
              <Typography variant="body2" sx={{ opacity: 0.8 }}>
                AI is working its magic
              </Typography>
            </Box>
          </Backdrop>

          {/* Success Snackbar */}
          <Snackbar
            open={showSuccess}
            autoHideDuration={3000}
            onClose={() => setShowSuccess(false)}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          >
            <Alert
              severity="success"
              sx={{
                borderRadius: 2,
                backgroundColor: isDarkMode ? "#065f46" : undefined,
                color: isDarkMode ? "white" : undefined,
              }}
            >
              {successMessage || "Action completed successfully!"}
            </Alert>
          </Snackbar>
        </Container>

        <style jsx>{`
          @keyframes pulse {
            0%,
            100% {
              opacity: 1;
            }
            50% {
              opacity: 0.5;
            }
          }
        `}</style>
      </Box>
    </>
  );
};

export default ModernSummarizer;
